{
  "neighborhoods": true,
  "country_code": "55",
  "currency_config_up": "BRL",
  "showLocale": true,
  "masks": {
    "mi": "KM",
    "phone": "(00) 0000-00009",
    "cell": "(00) 00000-0000",
    "secret_number": "000.000.000-00",
    "secret_number_company": "00.000.000/0000-00",
    "ssn_mask": "CPF/CNPJ",
    "secret_number_mask": "CPF",
    "zipcode": "00000-000",
    "date_mask": "dd/MM/yyyy",
    "date_mask_format_m": "DD/MM/YYYY",
    "date_mask_two": "dd/MM",
    "states": [
      "AC",
      "AL",
      "AP",
      "AM",
      "BA",
      "CE",
      "DF",
      "ES",
      "GO",
      "MA",
      "MT",
      "MS",
      "MG",
      "PA",
      "PB",
      "PR",
      "PE",
      "PI",
      "RJ",
      "RN",
      "RS",
      "RO",
      "RR",
      "SC",
      "SP",
      "SE",
      "TO"
    ]
  },
  "sort_by": "Ordenar por",
  "sale_without_registration": "Venda sem cadastro",
  "i_dont_need_indentify_client": "Não preciso identificar o cliente",
  "uf": "UF",
  "order_code": "Código do pedido",
  "favorite_card_comment": "Ex: Meu cartão favorito",
  "finalize_order_comment": "Finalizar Pedido",
  "goodbye": "Ate mais!",
  "opened": "aberto",
  "are_you_here": "você está aqui?",
  "closed": "fechado",
  "optional": "opcional",
  "possibles": "possíveis",
  "add_comment": "+Adicionar",
  "obs": "Observações",
  "your_location": "sua localização. arraste o marcador para ajustar.",
  "adjust_location": "Ajustar localização",
  "confirm_send_to_whatsapp": "Deseja enviar a mensagem de cancelamento via WhatsApp para o cliente?",
  "send_message": "Enviar Mensagem",
  "dont_send_message": "Não enviar mensagem",
  "my_orders": "meus pedidos",
  "tax_and_time_of_shipping": "taxa e tempo de entrega",
  "scheduling": "Encomendas",
  "scheduling2": "Agendamento",
  "package": "Encomenda",
  "close_order": "fechar pedido",
  "verify": "verificar",
  "add_more_items": "adicionar mais itens",
  "next": "Próximo",
  "cart_empty": "Carrinho Vazio",
  "edit_item": "editar item",
  "select_shipoing": "Escolha a Entrega",
  "take_out": "retirar no local",
  "pick_up_counter": "Retirar no Balcão",
  "cupom": "cupom",
  "active_your_cupom": "ativar seu cupom",
  "code_of_cupom": "código do cupom",
  "total": "total",
  "select_the_form_of_shipping": "Escolha a forma de entrega",
  "mandatory": "obrigatório",
  "go_to_payment": "ir para pagamento",
  "pay_on_app": "pagar no app",
  "pay_on_shippingg": "pagar na entrega",
  "discont": "Desconto",
  "discount_comment": "Desconto",
  "payment_in_comment": "Pagamento em",
  "cash_payment": "pagamento em dinheiro",
  "payment_debit_card": "pagamento em cartão de débito",
  "payment_credit_card": "pagamento em cartão de crédito",
  "i_need_transhipment": "preciso de troco para",
  "i_not_need_transhipment": "Não preciso de troco",
  "secret_number_on_note": "CPF/CNPJ na nota",
  "search_products_by_name_or_description": "Pesquisar Produtos por Nome ou descrição",
  "outside_the_coverage_area": "fora da área de cobertura",
  "unavilable": "Indisponível",
  "avaible": "disponível",
  "product_unavilable": "produto indisponível",
  "unavilable_amount": "quantidade indisponível",
  "table_s": "mesas",
  "discont_of": "desconto de",
  "free_freight": "frete grátis",
  "free_freight_comment": "Frete Grátis",
  "covered_address": "Endereço Fora de Cobertura",
  "send_order": "enviar pedido",
  "you_are_blocked": "você está bloqueado",
  "enter_your_cell": "preencha o Celular/WhatsApp",
  "enter_your_email": "digite seu email",
  "enter_your_address": "digite seu endereço",
  "enter_you_ddd": "Preencha o Celular/WhatsApp com DDD",
  "minimum_unconceived_value": "valor mínimo não atingido",
  "finish_payment_pix": "finalizar pagamento via pix",
  "finish_payment": "finalizar pagamento",
  "my_cards": "meus cartões",
  "payment_online": "pagamento online",
  "payment_offline": "pagamento na entrega",
  "add_new_card": "adicionar novo cartão",
  "pay_on_delivery": "pagar na entrega",
  "i_need_change_for": "preciso de troco para",
  "i_dont_need_change": "não preciso de troco",
  "send_the_receipt": "envie o comprovante em nosso whatsapp para agilizar o seu atendimento",
  "copy_key": "copiar chave",
  "select_the_flag": "Selecione a bandeira",
  "select_the_flag_comment": "Selecione uma Bandeira",
  "cpf_cnpj_on_the_receipt": "CPF/CNPJ na nota",
  "cpf_on_the_receipt": "CPF na nota",
  "cpf_cnpj_invalid": "CPF/CNPJ Inválido",
  "cpf_invalid": "CPF Inválido",
  "how_to_pay_with_pix": "Como pagar no PIX",
  "enter_cpf_generate_pix": "Digite seu CPF para gerar uma chave PIX",
  "enter_cpf": "Digite seu CPF",
  "enter_a_valid_cpf": "Insira um CPF Válido",
  "order_pending_payment": "pedido aguardando pagamento",
  "generate_pix_key": "Gerar chave PIX",
  "pix_copy_paste": "PIX Copia e cola",
  "copy_code": "copiar código",
  "pix_key_expired": "Sua chave PIX expirou. CLique no botão para gerar uma nova",
  "paste_this_code_your_bank": "Cole este código na opção de transferência Pix do seu banco",
  "verify_pix_payment": "Verificar pagamento do PIX",
  "card_details": "dados do cartão",
  "name_on_the_card": "nome no cartão",
  "card_number": "número do cartão",
  "expiry": "validade",
  "card_nickname": "apelido do cartão (opcional)",
  "billing_adress": "endereço da cobrança",
  "zip_code_not_found": "CEP não encontrado",
  "adress_line_2": "complemento (opcional)",
  "order_will_be_delivered": "o pedido será entregue à",
  "to_consult": "À Consultar",
  "flavors_comment": "Sabores",
  "flavor_comment": "Sabor",
  "crust": "Borda",
  "add_ons": "Complementos",
  "add_on": "Complemento",
  "general_toppings": "complementos gerais",
  "single_crust": "borda única",
  "message_cvv_payment": "Digite o código CVV do seu Cartão para finalizar o pagamento",
  "code_back_of_your_card": "este código fica atrás do seu cartão",
  "complete_payment": "finalizar pagamento",
  "what_card_nickname": "qual apelido desse cartão",
  "use_cashback": "utilizar saldo cashback",
  "balance": "saldo",
  "indentify_yourself": "identifique-se",
  "whatsapp_number": "Número do Whatsapp",
  "number_comment": "Número",
  "date_of_birth": "Data de Nascimento",
  "place_order_necessary_information": "para realizar o pedido acima, é necessário o preenchimento dos dados acima",
  "order_slip_s": "Comandas",
  "zip_invalid": "CEP inválido",
  "no_active_orders": "sem pedidos ativos",
  "order_sucess": "pedido realizado com sucesso",
  "send_confirmation_whatsapp": "enviar confirmação via whatsapp",
  "select_delivery_date": "selecione uma data para entrega",
  "time_zone_is_different": "Indentificamos que seu fuso horário é diferente do fuso horário do estabelecimento, ao lado do horário estará o seu respectivo horário de recebimento",
  "delivery_time_between": "escolha um horário de entrega entre os periodos",
  "delivery_for_order": "escolha um horário de entrega para sua encomenda",
  "establishment_notes": "observações do estabelecimento",
  "no_more_avaible_slots_for_orders": "não temos mais vagas disponíveis para encomendas, entre em contato com nosso estabelecimento",
  "contact_establishment": "fale com o estabelecimento",
  "no_slots_avaible_for_orders_on_that_day": "não temos mais vagas para encomendas no dia",
  "please_select_another_date": "por favor, selecione outra data.",
  "continue": "continuar",
  "last_orders": "Últimos pedidos",
  "view_order": "ver pedido",
  "edit_addresses": "editar endereços",
  "addresses": "endereço",
  "add_new_addresses": "cadastrar novo endereço",
  "create_address_or_use_list_below": "crie um novo endereço ou use a lista abaixo",
  "more_information": "mais informações",
  "notification_permissions": "para receber notificações é necessário aceitar a permissão de notificações em seu dispositivo.",
  "opening_hours": "horário de funcionamento",
  "from_de": "De",
  "to": "até",
  "pay_online": "pagar online",
  "choose_this_option_secure_payment": "escolha esta opção para realizar o pagamento de forma segura através de nosso sistema online.",
  "choose_option_receiving": "prefere pagar ao receber seu pedido? Escolha esta opção.",
  "acess_your_payment_app": "acesse seu app de pagamentos",
  "qrcode_copy_paste_payment": "escaneie o QR code ou copie e cole o código do pagamento",
  "pay_credited_instantly": "pague e será creditado na hora",
  "enter your cpf": "Digte seu CPF",
  "n": "Nº",
  "payment_still_pending": "pagamento ainda pendente. Por favor tente novamente.",
  "confirmation_is_taking_too_long": "se a confirmação estiver demorando muito, clique no botão para continuar.",
  "use_delivery_address": "usar endereço de entrega",
  "state": "estado",
  "payment_meal_voucher": "pagamento em vale refeição",
  "payment_food_voucher": "pagamento em vale alimentação",
  "receipt_to_our_whatsapp": "envie o comprovante em nosso whatsapp para agilizar o seu atendimento",
  "total_to_transfer": "total a transferir",
  "type_of_key": "tipo de chave",
  "save_future_purchases": "salvar para compras futuras",
  "finalize_order": "finalizar pedido",
  "choose_single_crust": "escolha a borda única",
  "choose_single_crust_comment": "Escolha a Borda Única",
  "choose_crust_comment": "Escolha a Borda",
  "crust_without_filling": "sem borda",
  "choose_the": "Escolha a",
  "choose_the_o": "Escolha o",
  "complete_order_mandotory": "complete o seu pedido com os itens obrigatórios",
  "no_orders_moment": "sem pedidos no momento",
  "fee_comment": "Taxa",
  "pickup_only": "somente retirada no local",
  "local_pickup": "Retirada no Local",
  "loading_dates": "carregando datas",
  "choose_date": "escolher uma data",
  "see_full_list": "clique aqui para ver a lista completa de produtos",
  "no_products_found": "desculpe, nenhum produto encontrado",
  "size_unavilable": "tamanho indisponível",
  "edit_notes": "editar observações",
  "remove_item": "remover item",
  "point_camera_qrcode": "por favor aponte a sua câmera para o QRCode da mesa em que deseja realizar o pedido",
  "order_status": "status do pedido",
  "in_preparation": "em preparo",
  "canceled": "cancelado",
  "order_received": "pedido recebido",
  "pending_payment": "aguardando pagamento",
  "order_approved": "pedido aprovado",
  "order_preparation": "pedido em preparo",
  "order_canceled": "pedido cancelado",
  "order_out_for_delivery": "pedido saiu para entrega",
  "order_ready_for_pickup": "pedido pronto para retirada",
  "send_order_whatsapp": "enviar pedido via whatsapp",
  "reference_point": "Ponto de Referência",
  "house_corner": "Casa da esquina",
  "address_complement": "Complemento",
  "block_apt": "Bloco, Apto",
  "ave": "Av. Brasil",
  "date_usa": "dd/mm/yyyy",
  "choose_time": "escolha um horário",
  "minimum_quantity": "Quantidade minima",
  "maximum_quantity": "Quantidade maxima",
  "what_your_name": "Qual o seu nome",
  "open_new_order": "Abrir nova comanda",
  "new_order": "Nova Comanda",
  "repeat_order": "repetir pedido",
  "edit_order": "editar pedido",
  "editing_ongoing": "Edição em Andamento",
  "enter_name_your_order": "Insira um nome para sua comanda",
  "select_order": "Selecione uma comanda",
  "counter_and_delivery": "Balcão/Delivery",
  "discount_of": "desconto de",
  "applied": "aplicado",
  "addition": "Acréscimo",
  "change_address": "mudar endereço",
  "message_no_costumer_selected": "Nenhum cliente selecionado para este pedido, busque por um cliente cadastrado o cadastre um para poder prosseguir.",
  "search_customer": "buscar cliente",
  "add_customer": "Cadastrar Cliente",
  "outside_service_area": "FORA DA ÁREA DE COBERTURA",
  "free_comment": "Grátis",
  "free_comment_up": "GRÁTIS",
  "activate_coupon_comment": "Ative seu Cupom",
  "order_type": "tipo de pedido",
  "place_order": "fazer pedido",
  "open_register": "abrir caixa",
  "initial_balance": "Saldo Inicial R$",
  "initial_balance_n": "Saldo Inicial",
  "income": "entrada",
  "cash_register_status": "status do caixa",
  "cash_outflow": "saída",
  "cash_outflows": "saídas",
  "cod": "cód.",
  "close_cash_register": "fechar caixa",
  "cash_balance": "saldo dinheiro",
  "cashier_balance": "saldo caixa",
  "final_balance": "saldo final",
  "create_order_slip": "criar comanda",
  "change_tables": "trocar de mesas",
  "table_change": "troca mesa",
  "print_table": "imprimir mesa",
  "close_table": "encerrar mesa",
  "whatsapp": "WhatsApp",
  "client_comment": "Cliente",
  "no_registred_address": "nenhum endereço cadastrado",
  "none": "nenhum",
  "no_categories_available_at_moment": "Nenhuma categoria disponível para pedidos do tipo mesa no momento.",
  "check_admin_panel_categories_active": "Verifique no painel de administrador se as categorias estão ativas e disponíveis para pedidos de tipo mesa.",
  "search_name_comment": "Buscar por código ou nome",
  "search_flavor_comment": "Buscar por código ou sabor",
  "waiting_service": "aguardando atendimento",
  "pause_comment": "Pausar",
  "unpause_comment": "Despausar",
  "order_buy": "pedir",
  "order_the_table": "pedir na mesa",
  "registration_comment": "Registrando",
  "change_comment": "Alterar",
  "one_more_comment": "Mais um",
  "customer": "clientes",
  "customer_name_comment": "Nome do cliente",
  "customer_last_name_comment": "Sobrenome do cliente",
  "email_example_comment": "cliente@exemplo.com",
  "ssn_model_comment": "000.000.000-00",
  "number_model_comment": "(00) 00000-0000",
  "order_by": "Pedido por",
  "delivery_address": "Endereço de Entrega",
  "no_number": "sem número",
  "dont_know_my_zip": "Não sei meu CEP",
  "other_s": "Outras",
  "deliver_this_address": "Entregar neste endereço",
  "out_coverage_area": "fora da área de cobertura",
  "error_generating_qrcode": "Erro ao gerar QR Code. Por favor, tente novamente.",
  "finalize_appointment": "fechar agendamento",
  "payment_not_detected_check_banking": "Pagamento não detectado. por favor verifique o aplicativo do seu banco.",
  "error_processing_payment": "Erro ao processar o pagamento, por favor tente novamente.",
  "error_creating_customer": "Erro ao criar cliente. Por favor tente novamente.",
  "return_cancel": "Voltar/Cancelar",
  "return": "Voltar",
  "remaining": "faltam",
  "fee_discount": "Taxa/Desconto",
  "how_pay_pix": "Como pagar no PIX",
  "step": "passo",
  "payment_deadline": "o tempo para pagamento acaba em",
  "select_comment": "Selecione",
  "call_back_house": "Ex: Chamar na Casa dos Fundos",
  "change_for_comment": "Troco Para",
  "for": "para",
  "out for delivery": "saiu para entrega",
  "waiting_for_pickup": "aguardando retirada",
  "add_flavor": "adicionar sabor",
  "your_flavor": " seu sabor",
  "choose": "Escolha",
  "choose_up_to": "Escolha até",
  "selected_date_is_earlier": "a data escolhida é anterior à atual. Por gentileza, escolha outro horário",
  "register_closing": "fechamento de caixa",
  "confirm_register_closing": "confirmar fechamento de caixa",
  "closing_insert_following": "ao realizar o fechamento, insira os seguintes valores na gaveta do seu caixa",
  "register_login": "login caixa",
  "deposit": "Depósito",
  "purpose": "finalidade",
  "list": "lista",
  "make_payment": "fazer pagamento",
  "uncancel_order": "descancelar pedido",
  "order_amount": "valor total do pedido",
  "print_the": "realizar impressão da",
  "next_flavor_comment": "Próximo Sabor",
  "choose_flavor_comment": "Escolha o Sabor",
  "quantity_unavaible": "Quantidade Indisponível",
  "complete_toppings_comment": "Complete os Complementos",
  "out_stock_toppings_comment": "Complementos Sem Estoque",
  "in_stock_comment": "Em Estoque",
  "the_flavors_comment": "os Sabores",
  "the_crust_comment": "as Bordas",
  "the_toppings_comment": "os Complementos",
  "mandatory_to_choose": "é obrigatório escolher",
  "time_closed_comment": "Horário Encerrado!",
  "change_less_purchase_comment": "Troco abaixo do valor da compra",
  "free_shipping_comment": "FRETE GRÁTIS",
  "consult_comment": "Consultar",
  "location_comment": "Local",
  "paid_online_comment": "Pago Online",
  "track_order": "Acompanhar Pedido",
  "order_comment": "Encomenda",
  "schedule": "Agendar",
  "closed_orders": "Fechado Encomendas",
  "scheduling_closed": "Agendamento Fechado",
  "order_name": "nome da comanda",
  "command_name": "Comanda",
  "no_product_found": "nenhum produto encontrado",
  "items_found": "itens encontrados",
  "mandatory_items": "itens obrigatorios",
  "minimum": "minímo",
  "advance": "Avançar",
  "add_another_card": "adicionar outro cartão",
  "loading_page": "Carregando...",
  "enter_city": "Digite a cidade",
  "select_city": "Selecione a cidade",
  "enter_neighborhood": "Digite o bairro",
  "select_neighborhood": "Selecione o bairro",
  "enter_street_name": "Digite o nome da rua",
  "coupon_only_used_purchases": "Esse cupom só pode ser usado em vendas a partir de",
  "discount_coupon_greater_total": "O desconto no cupom é maior do que o valor total!",
  "add_to_order": "Adicionar para encomenda",
  "data_print": "Data de impressão",
  "generate_fiscal_note": "Realizar Emissão de Nota Fiscal",
  "alert": {
    "unable_to_read": "Não é possível ler a sua localização, verifique se a localização não está bloqueada.",
    "address_covarage_area": "Seu endereço está fora da nossa área de cobertura!",
    "register_open_24": "Existe um caixa aberto há mais de 24 horas e ele será encerrado",
    "table_desactived": "Desculpe está mesa se encontra desativada!",
    "moment_table_not_avaible": "No momento, está mesa não está disponível para novos pedidos",
    "table_not_avaible_new_orders": "No momento, essa mesa não está disponível para novos pedidos.",
    "order_already_been_completed": "A comanda anterior já foi finalizada, você ainda esta no restaurante ou deseja fazer um novo pedido para entrega?",
    "at_the_table": "Estou na mesa",
    "deliver_order": "Entregar pedido",
    "not_belong_this_table": "Esta comanda não pertence a esta mesa",
    "store_closed": "LOJA FECHADA!",
    "not_minimum_value": "Seu pedido não atingiu o valor mínimo de",
    "failed_validate_coupon": "Falha ao validar cupom, verifique sua conexão!",
    "amount_not_include_delivery_fee": "Este valor total não inclui a taxa de entrega.",
    "coupon_used_starting_from": "Esse cupom só pode ser usado em compras a partir de",
    "closed_delivery": "FECHADO PARA DELIVERY",
    "unable_create_customer": "Não foi possível criar cliente. Por favor tente novamente.",
    "selected_date_earlier_choose_later_date": "A data escolhida é menor que a data atual,<br>favor escolher uma data maior.",
    "try_again_moment": "Algo inesperado aconteceu, tente novamente em instantes",
    "error_generate_qrcode": "Não foi possível gerar o QR Code. Por favor, tente novamente.",
    "payment_not_detected": "Pagamento não detectado. por favor verifique o aplicativo do seu banco.",
    "reloaded_page_message": "A página precisa ser recarregada!",
    "name_and_last_name_and_phone_required": "Nome, Sobrenome e telefone são obrigatórios",
    "enter_your_details": "Insira seus dados",
    "enter_your_name": "Insira seu nome",
    "enter_your_whatsapp": "Insira seu WhatsApp",
    "enter_your_date_of_birth": "Insira sua data de nascimento",
    "review_change_amount": "Revise o valor do troco!",
    "no_internet_connection": "Sem conexão com a internet!"
  },
  "calendar": {
    "weekdays": ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"],
    "months": [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ]
  },
  "timezones": [
    {
      "label": "Acre",
      "value": "America/Rio_Branco"
    },
    {
      "label": "Brasília",
      "value": "America/Sao_Paulo"
    },
    {
      "label": "Manaus",
      "value": "America/Manaus"
    },
    {
      "label": "Fernando de Noronha",
      "value": "America/Noronha"
    }
  ],
  "unitSystem": "metric",
  "distanceinkmto": "Distância em KM até",
  "distance": "Distância",
  "the_distance_already_exists": "Essa distância ja existe",
  "distance_added_successfully": "Distância adicionada com sucesso!",
  "distance_deleted_successfully": "Distância excluída com sucesso!",
  "update_shipping": "Atualizar frete",
  "km": "KM",
  "tobeconfirmed": "A Consultar",
  "time": "Tempo",
  "coin": "R$",
  "currency_config": "brl",
  "ddi": "55",
  "date_format": "dd/MM/yyyy",
  "date_format_v2": "dd/MM",
  "order_updated_at": "Editado em",
  "welcome": "Bem vindo!",
  "description": "Descrição",
  "orders": "Pedidos",
  "order": "Pedido",
  "order_management": "Gestão de pedidos",
  "new_feature": "Recurso novo",
  "work_waiters_taking": "Você trabalha com garçons tirando pedidos?",
  "register_you_waiters_quickly": "Então Cadastre seus garçons e lance pedidos rapidamente.",
  "dont_work_waiters": "Não trabalho com garçons",
  "register_waiters": "Cadastrar meus garçons",
  "orders_were_not_received": "Pedidos que não foram recebidos.",
  "orders_appointments": "Encomendas/Agendamentos",
  "efficiency": "Agilidade",
  "incredible_agility": "Incredible agility in table and order management never seen before; this system is everything you’ve always dreamed of to earn more money and organize your restaurant.",
  "automation": "Automatização",
  "now_you_control": "Agora você controla as mesas e comandas do seu restaurante de forma automática, sem erros ou mão de obra extra para tirar os pedidos.",
  "qrcode_self_service": "Tecnologia QRCode de auto-atendimento por mesa, não precisa do garçom tirador de pedidos.",
  "self_service": "Auto-atendimneto",
  "customers_place_orders_themselves": "Com este auto-atendimento os seus clientes pedem sozinhos na mesa e os pedidos são impressos automaticamente direto na sua cozinha por ordem na fila.",
  "zero_waste": "Zero perda",
  "indecipherable_handwriting": "Chega daquelas letras indecifráveis, erros e prejuízos no preparo dos pratos, mantenha tudo funcionando com muita agilidade no seu restaurante.",
  "closure": "Encerramento",
  "automatically_separates_calculates": "Fechamento rápido da conta direto na mesa ou no caixa, o WhatsMenu separa e calcula sozinho o que cada comanda consumiu permitindo cobrar individualmente o cliente que vai embora antes da mesa ser encerrada, permitindo fechamentos com tranquilidade e livre de erros.",
  "ordering_system": "O Sistema de Encomenda",
  "allows_your_customer": "Permite ao seu cliente escolher o dia e horário para receber seu pedido.",
  "allows_customer_they_wish": "Permite que o cliente escolha o dia e horário em que deseja receber o pedido.",
  "you_can_sell_24h": "Você pode vender 24h, mesmo com seu estabelecimento fechado.",
  "prevents_setbacks": "Evita contratempos, como o cliente não estar disponível para receber o pedido e o entregador perder a viagem.",
  "advantages": "Vantagens",
  "configure_days_establishment": "Configure os dias e horários aceitos pelo estabelecimento.",
  "customer_best_time_for_them": "O cliente escolhe o melhor horário para ele",
  "helps_improve": "Ajuda à melhor organização na logística de entrega",
  "speak_with_consultant": "Falar com consultor agora",
  "must_be_between": "O valor deve estar entre 0.49 e 0.99",
  "acess": "Acesse",
  "delete_addresses": "Excluir Endereços",
  "addresses_deleted": "Endereços excluídos com sucesso!",
  "control_of": "Controle de",
  "error_deleting_addresses": "Erro ao excluir endereços. Verifique o console para mais detalhes.",
  "user": "Usuário",
  "sucess_updated": "atualizado com sucesso",
  "something_wrong": "Deu ruim",
  "talk_it_team": "Falar com o pessoal do T.I",
  "user_profile": "Perfil do Usuário",
  "profile": "Perfil",
  "asaas_account_disconnected": "Conta Asaas desvinculada do Perfil",
  "unable_disconnect_asaas_account": "Não foi possível desvincular a Conta Asaas do Perfil",
  "additionals": "Adicionais",
  "there_no_services_generate": "Não há serviços para gerar",
  "boleto_generated": "Boleto gerado com sucesso",
  "issue_add_ons": "Emitir Adicionais",
  "make_sure_boleto_generated": "Certifique-se que foi gerado um boleto para esta fatura",
  "invoice_settlement": "Baixa de Fatura",
  "reset_security_key": "Resetar chave de segurança",
  "assign_support": "Atribuir Suporte",
  "acessing_user_account": "Acessando conta do usuário",
  "logging_in": "Logando...",
  "back_to_list": "Voltar para lista",
  "menu": "Cardápio",
  "client_contracted_menu_registration": "Cliente contratou cadastro de cardápio",
  "printer": "Impressora",
  "client_purchased_printer": "O cliente comprou impressora",
  "user_data": "Dados do Usúario",
  "salesperson": "Vendedor",
  "responsible_support": "Suporte Responsável",
  "name": "Nome",
  "no_name": "Sem nome",
  "no_email": "Sem email",
  "invalid_email": "Email inválido",
  "owner_email_address": "Email do dono do estabelecimento",
  "ssn_ein": "CPF/CNPJ",
  "no_ssn_ein": "Sem CPF/CNPJ",
  "invalid": "Inválido",
  "no_whatsapp": "Sem WhatsApp",
  "full_name": "Nome completo",
  "register_customer": "Cadastrar Cliente",
  "registration_date": "Data de Cadastro",
  "no_date": "Sem data",
  "select_payment_gateway_for_user": "Selecione o gateway de pagamento para o usuário antes de continuar",
  "login_attempts": "Tentativas de Login",
  "due_date": "Vencimento",
  "payment_method": "Forma de Pagamento",
  "card": "Cartão",
  "password": "Senha",
  "your_password": "Sua senha",
  "passwords": "Senhas",
  "enter_new_password": "Digite a nova senha",
  "security_key": "Chave de segurança",
  "reset": "Resetar",
  "access_panel": "Acessar Painel",
  "language": "Idioma",
  "country": "Pais",
  "brazil": "Brasil (R$)",
  "phone_footer": "Telefone",
  "phone_abbreviation": "Tel.",
  "united_states": "Estados Unidos ($)",
  "portugal": "Portugal (€)",
  "united_kingdom": "Inglaterra (£)",
  "jamaica": "Jamaica (J$)",
  "paraguay": "Paraguai (₲)",
  "mexico": "México (MXN$)",
  "dubai": "Dubai (د.إ)",
  "grenada": "Granada (EC$)",
  "ireland": "Irlanda (€)",
  "select_language": "Selecione o Idioma",
  "currency": "Moeda",
  "select_currency": "Selecione a Moeda",
  "portuguese_brazil": "Português (Brasil)",
  "portuguese_portugal": "Português (Portugal)",
  "spanish_paraguay": "Spanish (Paraguay)",
  "english_us": "Inglês (US)",
  "english_uk": "Inglês (Grã-Bretanha)",
  "english_jamaica": "Inglês (Jamaica)",
  "spanish_mexico": "Espanhol (Mexico)",
  "english_grenada": "Inglês (Grenada)",
  "english_ar": "Inglês (Dubai)",
  "english_ireland": "Inglês (Irlanda)",
  "german_de": "Alemão (Alemanha)",
  "internationalization": "Internacionalização",
  "not_registered": "Não Cadastrado",
  "not_have_permission_adm": "Você não tem permissão para acessar uma conta Administradora",
  "clear_addresses": "Limpar Endereços",
  "clear": "Limpar",
  "delete_addresses_customer": "Deseja excluir todos os endereços ou apenas os fora da área de entrega?",
  "outside_area": "Fora da área",
  "no": "Não",
  "yes": "Sim",
  "user_cancellation": "Cancelamento Usuário",
  "cancel_charges_user": "Cancelar cobranças deste usuário?",
  "version_next": "Versão Next",
  "test": "teste",
  "activate": "Ativar",
  "automatic_printing_browser": "Impressão Automática pelo navegador",
  "observations": "Observações",
  "save": "Salvar",
  "title": "Título",
  "block_profile": "Bloquear Perfil",
  "value_whatsapp": "Valor no Whatsapp",
  "enable_shipping_mi": "Permitir trocar frete entre quilometragem e por bairro",
  "double_sending_whatsapp": "Duplo envio Whatsapp",
  "enable_pix_online": "Habilitar Pix Online",
  "enable_online_card": "Habilitar Cartão Online",
  "remove_type_street": "Remover logradouro de endereço?",
  "old_pix": "Pix antigo",
  "negotiation_fee": "Taxa negociação",
  "days": "dias",
  "expires_in": "Expira em",
  "expired_since": "Expirou a",
  "disconnect_account_asaas": "Desvincular Conta Asaas",
  "unlink": "Desvincular",
  "account_asaas": "Conta Asaas",
  "unlink_asaas_account": "Você deseja desvincular a conta Asaas desse cliente",
  "quantity": "Quantidade",
  "issue": "Emitir",
  "number_installments": "Quantidade de Parcelas",
  "invoices": "Faturas",
  "transaction_id": "ID da Transação",
  "value": "Valor",
  "total_order": "Total do Pedido",
  "action": "Ação",
  "action_remove_user_the": "Esta ação irá remover usuário da",
  "notice": "Aviso",
  "settlement": "Baixa",
  "warning_financial_password": "ATENÇÃO! Você precisa Cadastrar uma Senha Financeira.",
  "warning_v2": "Para isso acesse no menu a opção Configurações",
  "passwords_or": "Senhas ou",
  "click_here": "Clique Aqui",
  "enter_financial_password": "Digite sua Senha Financeira",
  "confirm": "Confirmar",
  "forgot_financial_password": "Esqueceu sua Senha Financeira",
  "recover_password": "Recuperar Senha",
  "check_inbox_spam": "verifique na 'caixa de entrada' ou 'spam'",
  "message_subject": "a mensagem com o assunto",
  "password_recovery": "Recuperação de Senha",
  "whastmenu": "Whatsmenu",
  "start_date": "Data Inicial",
  "end_date": "Data Final",
  "search": "Buscar",
  "print": "Imprimir",
  "report": "Relatório",
  "product": "Produto",
  "products": "Produtos",
  "product_m": "produto",
  "qty_sold": "Qto. Vendido",
  "total_amount": "Valor Total",
  "cash_summary": "RESUMO CAIXAS",
  "qty": "Qntd.",
  "incomes": "Entradas",
  "table_closing": "Encerramento mesa",
  "table": "Mesa",
  "counter": "Balcão",
  "request": "Encomenda",
  "cancelled": "Cancelados",
  "cancelled_up": "CANCELADO",
  "cancelled_o": "Cancelado",
  "outflows": "Saídas",
  "n_orders": "Nº de Pedidos",
  "client": "Cliente",
  "average_ticket": "Ticket Médio",
  "total_spent": "Total Gasto",
  "total_orders": "Total de pedidos",
  "total_amount_spent": "Valor total gasto",
  "customer_report": "Relatório do cliente",
  "number_of_orders": "Qtd. de Pedidos",
  "order_history": "Histórico de Pedidos",
  "order_cod": "Cod. Pedido",
  "change_for": "Troco Para",
  "change": "Troco",
  "payment": "Pagamento",
  "payment_abbreviation": "Pgto.",
  "all_customers": "Todos Clientes",
  "filter": "Filtrar",
  "order_volume": "Volume de Pedidos",
  "amount_consumed": "Valor Consumido",
  "no_results_found": "Nenhum resultado encontrado",
  "no_customer_found": "Nenhum cliente encontrado com esse nome",
  "phone_number": "Telefone",
  "customer_found": "Clientes Encontrados",
  "opening_time_must_closing": "O horário de abertura tem que ser maior que o de fechamento!",
  "time_will_not_take": "Esse horário não surtirá efeito no",
  "following": "Seguinte",
  "day": "Dia",
  "changing_existing_time": "considere alterar um horário ja existente no",
  "mentioned": "Citado",
  "please_select_day": "Por favor selecione um dia!",
  "please_set_valid_time": "Por favor Defina um horário válido!",
  "operating_hours": "Horário de funcionamento",
  "the_change_were": "As alterações não foram feitas pois há horários inválidos. Por favor corrija os campos destacados e tente novamente",
  "product_availability": "Disponibilidade de produtos",
  "setting_operating_hours": "Cadastrando horários de funcionamento",
  "choose_days_times": "ESCOLHA OS DIAS E OS HORÁRIOS",
  "select_all": "Selecionar Todos",
  "time_zone_successfully_changed": "Fuso horário alterado com sucesso",
  "from": "Das",
  "until": "Até",
  "add": "Adicionar",
  "open": "Abrir",
  "close": "Fechar",
  "actions": "Ações",
  "invalid_time": "Horário inválido",
  "if_work_overnight": "Caso você trabalhe também de madrugada, ou seja após meia noite, cadastre desta maneira",
  "pause": "Pausar",
  "unpause": "Despausar",
  "delete": "Excluir",
  "type": "Tipo",
  "priority": "Prioridade",
  "email_server": "Servidor de Email",
  "content": "Conteúdo",
  "destination": "Destino",
  "address": "Endereço",
  "discount": "Desconto",
  "surchage": "Acréscimo",
  "fixed": "Fixo",
  "percentage": "Percentual",
  "type_of_fee": "Tipo de Taxa",
  "type_of_value": "Tipo de Valor",
  "fee_amount": "Valor da Taxa",
  "copy": "CÓPIA",
  "successfully_duplicated": "foi duplicada com sucesso",
  "not_possible_duplicate": "Não foi possível duplicar a categoria",
  "unable_duplicate_product": "Não foi possível duplicar o produto",
  "category": "Categoria",
  "successfully": "com sucesso",
  "the_category": "a categoria",
  "could_not": "Não foi possível",
  "paused": "Pausado",
  "unpaused": "Despausado",
  "the_product": "o produto",
  "sizes": "Tamanhos",
  "size": "Tamanho",
  "edges_doughs": "Bordas e Massas",
  "flavors": "Sabores",
  "menu_information": "Informações do Cardápio",
  "cat_standard": "Cat. Padrão",
  "qty_product": "Qtd. Produto",
  "qty_add_ons": "Qtd. Complementos",
  "qty_size": "Qtd. Tamanhos",
  "qty_edges_doughs": "Qtd. Bordas/Massas",
  "qty_flavors": "Qtd. Sabores",
  "you_edited": "Você editou",
  "items": "itens",
  "cancel_edit_message": "Deseja cancelar a edição",
  "there_are_no": "Não há",
  "to_update": "para atualizar",
  "package_s": "Encomendas",
  "appointments": "Agendamentos",
  "appointment": "Agendamento",
  "share_facebook": "Compartilhar no Facebook",
  "copy_clipboard": "Copiar para o clipboard",
  "copied": "Copiado",
  "link_sucess_copied": "Link copiado com sucesso.",
  "unlink_link_copied": "Não foi possível copiar o link, seu navegador não tem suporte.",
  "message_menu_adjust_prices": "O cardápio é sua vitrine de produtos no WhatsMenu. Aqui você pode criar categorias, inserir itens, complementos e opcionais, definir disponibilidade e alterar preços.",
  "add_category": "Adicionar Categoria",
  "reorder_menu": "Reordernar Cardápio",
  "search_g": "Pesquisar",
  "search_place": "Pesquisar...",
  "complements": "Complementos",
  "complement": "Complemento",
  "pizza_flavors": "Sabores de Pizza",
  "duplicate": "Duplicar",
  "edit": "Editar",
  "stock": "Estoque",
  "low": "Baixo",
  "out_stock": "Esgotado",
  "edit_cover": "Editar Capa",
  "add_size": "Adicionar Tamanho",
  "add_item": "Adicionar Item",
  "add_complements": "Adicionar Complemento",
  "edit_flavors": "Editar Sabores",
  "cancel_edit": "Cancelar Edição",
  "prices": "Preços",
  "price": "Preço",
  "photo": "Foto",
  "discard_changes": "Descartar alterações",
  "enter_valid_value": "Por favor insira um valor válido!",
  "in_stock": "EM ESTOQUE",
  "add_flavors_firt_pizza": "Para adicionar sabores, crie um tamanho de pizza primeiro.",
  "add_flavors": "Adicionar Sabores",
  "updated_now": "Atualizado(s) agora",
  "flavors_will_be": "sabores serão",
  "flavor_will_be": "sabor será",
  "please_wait": "Aguarde...",
  "please_wait_n": "Aguarde",
  "edit_products": "Editar Produtos",
  "products_will_be": "produtos serão",
  "product_will_be": "produto será",
  "no_results_your_search": "Nenhum resultado para sua pesquisa",
  "no_category_registred": "Nenhuma categoria cadastrada",
  "add_items_bulk": "Adicionar itens em massa",
  "you_changing_promotional_price": "Você está alterando o valor promocional do produto.",
  "system": "Sistema",
  "cash_detail": "Detalhamento caixa",
  "operator": "Operador",
  "image_preview": "Pré-Visualização de Imagem",
  "width": "Largura",
  "height": "Altura",
  "complete": "Finalizar",
  "review_entered_data": "Por favor, revise os dados inseridos.",
  "confirm_financial_password": "Confirmar Senha Financeira",
  "financial_password": "Senha Financeira",
  "how_to_make": "Como Fazer",
  "updated": "atualizada",
  "updated_o": "atualizado",
  "created": "criada",
  "unable_delete_category": "Não foi possível excluír a categoria",
  "standard": "Padrão",
  "delete_category": "Excluir a categoria",
  "review_data": "Revise os Dados",
  "details": "Detalhes",
  "availability": "Disponibilidade",
  "select_category_model": "Selecione o modelo da categoria",
  "acai_ice_creams": "Açaís e Sorvetes",
  "burgers": "Hambúrgueres",
  "meal_boxes": "Marmitas",
  "meal_boxes_size_options": "Marmitas com escolha de tamanhos",
  "build_meal_box": "Monte sua marmita",
  "butcher_shop": "Açougue",
  "produce_section": "Hortifruit",
  "drinks": "Bebidas",
  "category_name": "Nome da Categoria",
  "invalid_category_name": "Nome da categoria inválido",
  "characters": "Caracteres",
  "minimum_stock": "Estoque Mínimo",
  "add_availability_hours": "Adicionar Horário de Disponibilidade",
  "add_promotion_hours": "Adicionar horários da promoção",
  "use_addons_another_item": "Usar complementos de outro item",
  "creating_addons": "Criando complementos",
  "shared_addons": "Complementos compartilhados",
  "attention": "Atenção",
  "attention_up": "ATENÇÃO",
  "all_changes_addon_affect_other_product": "Todas alterações feitas nesse complemento terão efeito em outros produtos que o utilizarem",
  "link": "Vincular",
  "attention_addon_linked": "Atenção este complemento está vinculado a",
  "attention_addon_linked_v2": "qualquer alteração feita aqui afetará os produtos vinculados, exceto excluir.",
  "other": "outro",
  "view_linked_products": "Ver Produtos Vinculados",
  "invalid_name": "Nome inválido",
  "min_greater_max": "Mín deve ser pelo menos 1.",
  "max_less_min": "Máx deve ser maior que o mín",
  "mandatory_addon": "Complemento Obrigatório",
  "options": "Opções",
  "please_enter_valid_value": "Por favor, insira um valor válido",
  "always_available": "Sempre disponível",
  "enable_stock": "Habilitar Estoque",
  "created_o": "criado",
  "create": "Criar",
  "was_deleted_successfully": "foi deletado com sucesso",
  "could_not_delete_flavor": "Não foi possível deletar o sabor",
  "you_really_want_delete": "Deseja realmente excluir",
  "error": "erro",
  "the_flavor": "o sabor",
  "flavor": "Sabor",
  "image_up_8": "Imagem com até 8mb",
  "add_image": "Adicionar Imagem",
  "recomended_resolution_600": "resolução recomendada de 600x450",
  "please_valid_name": "Por favor insira um nome válido",
  "message_pause_sales": "Para pausar as vendas deste item, clique no botão ao lado. Se o botão estiver habilitado, o item não aparecerá na sua lista de pratos.",
  "pause_sales": "Pausar Vendas",
  "resume_sales": "Despausar Vendas",
  "created_successfully": "criado com sucesso.",
  "updated_successfully": "atualizada com sucesso.",
  "was_not_created": "não foi criada.",
  "was_not_updated": "não foi atualizada.",
  "deleted_successfully": "deletada com sucesso.",
  "could_not_delete": "Não foi possível deletar",
  "could_not_pause": "Não foi possivel pausar",
  "resumed_successfully": "despausada com sucesso",
  "paused_successfully": "pausada com sucesso",
  "to_pause_sale_message": "Para pausar as vendas deste item, clique no botão ao lado. Se o botão estiver habilitado, o item não  aparecerá na sua lista de pratos.",
  "size_name_already_exists": "Já existe um tamanho com este nome",
  "the_size": "o tamanho",
  "update": "Atualizar",
  "message_delete_remove_another": "Para excluir é necessário apagar os sabores ou adicionar outro tamanho de pizza",
  "message_really_delete_size": "Deseja realmente excluir o tamanho",
  "message_could_not_delete": "Não foi possível excluír o tamanho",
  "edit_size": "Editar Tamanho",
  "cover": "Capa",
  "this_size_accepts": "Esse tamanho aceita",
  "add_cover": "Adicionar Capa",
  "message_cannot_invalid_times": "As alterações não podem ser feitas pois há horários inválidos. Por favor corrija os campos destacados e tente novamente",
  "review_not_allowed": "Revise seus complementos, não é permitido nome vázio",
  "could_not_delete_product": "Não foi possível excluir o produto",
  "delete_the_product": "Excluir o produto",
  "promotion": "Promoção",
  "activate_promotion": "Ativar promoção",
  "button_enable_disable_promotion": "Use o botão ao lado para habilitar ou desabilitar a promoção.",
  "original_price": "Valor Original",
  "promotional_price": "Valor Promocional",
  "promotion_ends_in": "Acaba em",
  "available_for": "Disponível para",
  "message_products_not_created": "Os Produtos não foram criados pois há horários inválidos. Por favor corrija os campos destacados e tente novamente",
  "products_created_successfully": "Todos os produtos foram criados com sucesso.",
  "products_not_created": "Produtos não foram criados.",
  "create_products_bulk": "Criar Produtos em Massa",
  "shortcuts": "Atalhos",
  "right_arrow": "Seta Direita",
  "left_arrow": "Seta Esquerda",
  "next_step": "Próximo Passo",
  "back_one_step": "Voltar um Passo",
  "create_products": "Criar Produtos",
  "add_product": "Adicionar Produto",
  "duplicate_product": "Replicar Produto",
  "product_name": "Nome do Produto",
  "table_price": "Preço Mesa",
  "product_description": "Descrição do Produto",
  "duplicate_r": "Replicar",
  "no_product_added": "Nenhum produto adicionado",
  "creating_products": "Criando Produtos...",
  "reordered_successfully": "Reordenado com successo",
  "could_not_reorder_items": "Não foi possível reordernar os itens",
  "message_press_and_hold": "Aperte e segure por 1 segundo e arraste os itens para posição desejada, esta sequência também refletirá na sua loja.",
  "reordegring_wait": "Reordenando, aguarde...",
  "you_any_categories_yet": "Você ainda não cadastrou nenhuma categoria.",
  "please_review_data": "Por Favor, revise os dados.",
  "review": "Revisão",
  "fee_shipping": "Frete Grátis",
  "fee_shipping_up": "FRETE GRÁTIS",
  "fee": "Taxa",
  "disc": "Desc.",
  "free": "Grátis",
  "be_determined": "À Consultar",
  "disabled": "Desativada",
  "order_slip": "Comanda",
  "order_slips": "Comandas",
  "ssn": "CPF",
  "duration": "Permanência",
  "delivery_date": "Data de Entrega",
  "no_time_up": "SEM HORÁRIO",
  "paid_up": "PAGO",
  "coupon_used": "Cupom usado",
  "delivery": "Entrega",
  "coupon": "Cupom",
  "payment_in": "Pagamento em",
  "total_paid": "Total Pago",
  "checkout": "Fechamento",
  "paid_online_up": "PAGO ONLINE",
  "delivery_person": "Entregador",
  "s_n": "S/N",
  "technology": "Tecnologia",
  "missing": "Faltam",
  "waiter": "Garçom",
  "paid": "Pago",
  "delivery_fee": "Taxa de Entrega",
  "printing_error": "Erro na impressão",
  "could_not_send_printing": "Não foi possível enviar a cópia para impressão.",
  "order_confirmation": "Confirmação de pedido",
  "could_not_print_order": "Não foi possivel realizar a confirmação de impressão do pedido",
  "change_date": "Alterar Data",
  "pending_prints": "Impressões Pendentes",
  "message_pending_print": "pedidos pendentes para impressão, deseja realizar a impressão destes pedidos?",
  "there_are": "Há",
  "print_all": "Imprimir Todos",
  "could_not_play_sound": "Não foi possível reproduzir o som.",
  "printing_up": "IMPRIMINDO",
  "cancel_order": "Cancelar Pedido",
  "reinstate_order": "Descancelar Pedido",
  "no_orders_print_up": "NÃO HÁ PEDIDOS PARA IMPRIMIR",
  "order_preview": "Pré Visualização do Pedido",
  "teste_print_order": "Pedido para Teste de Impressão",
  "report_request": "Pedido de Relatório",
  "received": "Recebido",
  "preparation": "Preparo",
  "delivering": "Entregando",
  "served": "Servido",
  "ready_for_pickup": "Pronto Retirar",
  "speak_customer": "Falar com Cliente",
  "select": "Selecione",
  "add_address": "Adicionar Endereço",
  "edit_address": "Editar Endereço",
  "filling_establishment_address": "Preenchendo o Endereço do Estabelecimento",
  "zip_code": "CEP",
  "invalid_zip_code": "CEP inválido",
  "number": "Número",
  "neighborhood": "Bairro",
  "city": "Cidade",
  "complete_address": "Completar Endereço",
  "confirm_location": "Confirmar localização",
  "confirm_and_fill_address": "Confirme e preencha os dados adicionais do seu endereço.",
  "enter_your_zip_code_for_address": "Informe seu CEP para encontrar o endereço.",
  "requesting_your_location": "Solicitando sua localização...",
  "address_found": "Endereço encontrado",
  "confirm_address": "Confirmar endereço",
  "enter_your_zip_code": "Digite seu CEP",
  "i_do_not_know_my_zip_code": "Não sei meu CEP",
  "save_address": "Salvar endereço",
  "choose_saved_address_or_create_new": "Escolha um endereço salvo ou cadastre um novo para seguir com o pedido.",
  "use_my_location": "Usar minha localização",
  "no_saved_address_for_this_client": "Nenhum endereço foi salvo ainda para este cliente.",
  "select_delivery_location": "Selecione o local de entrega",
  "inform_city_and_neighborhood_for_delivery": "Informe a cidade e o bairro para calcular a taxa de entrega.",
  "searching": "Buscando...",
  "complement_address": "Apto, Bloco, etc.",
  "delivery_to_your_address": "Entrega em seu endereço",
  "enter_registed_email_recover_password": "Digite seu email de cadastro para recuperar sua senha",
  "your_email": "Email de cadastro",
  "please_enter_valid_email": "Insira um email válido",
  "email_sent_successfully": "Email enviado com sucesso",
  "send": "Enviar",
  "delivery_package": "DELIVERY/ENCOMENDAS",
  "change_order_date": "Alterar Data Pedido",
  "selected_date": "Data Escolhida",
  "current_order_date": "Data Atual do Pedido",
  "distribution": "Distribuição",
  "order_coder": "Código do Pedido",
  "no_order_selected": "Nenhum Pedido Selecionado",
  "go_back": "Voltar",
  "pickup": "Retirada",
  "deliver": "Entregar",
  "no_items_this_date": "Nenhum item para esta data",
  "all": "Todos",
  "pending": "Em Espera",
  "marked_received": "Marcados C/ Recebidos",
  "local_delivery": "Entrega Local",
  "summary_of": "Resumo de",
  "your": "seus",
  "your_a": "suas",
  "filter_use": "Filtro em uso",
  "choose_date_summary": "Escolha uma data para resumo",
  "printing": "Impressão",
  "selected_orders": "Pedidos Selecionados",
  "regarding": "Referente",
  "calendar_view": "Modo Calendário",
  "loading_orders": "Carregando pedidos...",
  "order_slip_fees": "Taxas Comanda",
  "fees": "Taxas",
  "charge": "Cobrar",
  "next_confirm": "Próximo/Confirmar",
  "back_cancel": "Voltar/Cancelar",
  "proceed": "Prosseguir",
  "delivery_report": "Relatório de Entregadores",
  "qty_of_deliveries": "Entregas",
  "total_delivery_fees": "Taxas",
  "delivery_report_r": "Relatório de Entregas",
  "code_order": "Cod. Pedido",
  "date": "Data",
  "discard": "Descartar",
  "pending_changes": "Alterações Pendentes",
  "you_whant_save_them": "Existem alterações não salvas, deseja salvar?",
  "new": "Novo",
  "my_profile": "Meu Perfil",
  "delivery_drivers": "Entregadores",
  "tables": "Mesas",
  "no_active_waiter": "Nenhum garçom ativo",
  "message_register_waitr_enable": "Para registrar um garçom ou habilitar um já existente vá em Configurações > Mesa > na aba de Garçons, ou clique em",
  "register_waiter": "Cadastrar Garçom",
  "coupons": "Cupons",
  "social_media": "Mídia Social",
  "reports": "Relatórios",
  "financial_report": "Relatório Financeiro",
  "daily_orders": "Pedidos Diários",
  "monthly_orders": "Pedidos Mensais",
  "cash_register_closing": "Fechamento Caixa",
  "best_sellers": "Mais Vendidos",
  "customer_report_side": "Relatório Clientes",
  "general": "Gerais",
  "cash_registers": "Caixas",
  "domains": "Domínios",
  "payment_methods": "D. de Pagamento",
  "administrator": "Administrador",
  "support_bonus": "Bônus Suporte",
  "salesperson_report": "Relatório Vendedor",
  "annual_report": "Relatório Anual",
  "updates": "Atualizações",
  "exit": "Sair",
  "support_hours": "segunda à sábado",
  "settings": "Configurações",
  "phone": "Telefone",
  "press": "Aperte",
  "order_already_printed": "Pedido já foi impresso",
  "order_not_printed": "Pedido não impresso",
  "wait_order_printed": "Aguarde o pedido ser impresso",
  "displaying": "Exibindo",
  "of": "de",
  "filter_o": "Filtro",
  "caption": "Legenda",
  "order_list": "Lista de pedidos",
  "message_download_whatsmenu_desktop": "Baixe agora o NOVO WhatsMenu Desktop",
  "message_less_work": "Menos Trabalho e Mais Vendas",
  "message_virtual_assistant": "Atendente virtual para WhatsApp",
  "with_area_code": "Com DDD",
  "owner_cell_phone": "Celular do dono do estabelecimento",
  "message_loyalty_program": "Programa de Fidelidade",
  "message_first_purchase": "Cupom de primeira compra",
  "message_automated_sales_bot": "Robô de vendas automatizadas",
  "message_status_updates": "Envio de status sem abertura de abas",
  "message_download_app": "Baixar Aplicativo",
  "donwload_the_whatsmenu": "Baixe o WhatsMenu Desktop",
  "message_download_whatsmenu_printers": "Baixe agora o Novo WhatsMenu Impressoras",
  "message_automatic_printing_mobile": "Impressão automática no celular",
  "message_printing_multiple_printers": "Impressão em múltiplas impressoras",
  "message_copy_printing": "Impressão de cópias",
  "message_download_gplay": "Baixar pelo Google Play",
  "message_downlaod_whatsmenu_printers": "Baixe o WhatsMenu Impressoras",
  "message_audio_disabled": "Áudio desabilitado. Por favor interaja com a tela para habilitar.",
  "message_monthly_invoice_available": "Fatura de mensalidade disponível para pagamento! Clique aqui.",
  "message_menu_locked": "Seu cardápio pode ser bloqueado, pois sua mensalidade esta em atraso! Clique aqui.",
  "overview_pos_pizza_addons": "Visão Geral PDV e Adicionais de Pizza WhatsMenu",
  "how_to_register_customer_pos": "Como cadastrar um cliente no PDV",
  "guide_placing_order_pos": "Passo a passo para fazer um pedido via PDV",
  "how_to_update_customer_information_pos": "Como alterar informações do cadastro do cliente via PDV",
  "guide_opening_cash_register": "Passo a Passo para abertura do caixa",
  "guide_closin_cash_register": "Passo a Passo para fechamento de caixa",
  "cash_register_closing_reports": "Relatórios de encerramento de Caixa",
  "how_place_order_counter_pos": "Como fazer um pedido para retirada no balcão via PDV",
  "reordering_customers_orders": "Repetindo os pedidos anteriores de clientes em poucos cliques",
  "place_order_pizza_pos": "Como fazer pedido de pizza de 2 sabores ou mais, bordas e adicionais via PDV",
  "how_create_tables": "Como criar mesas",
  "guide_registering_pizza_crusts": "Passo a passo para cadastrar pizzas com bordas e complementos",
  "pos": "PDV",
  "internet_connection_lost": "Sua conexão com a internet foi perdida, verifique sua conexão.",
  "internnet_connection_reestablished": "Sua conexão com a internet foi reestabelecida.",
  "register_your_customers_quickly_easily": "Faça o cadastro dos seus clientes e realize pedidos de maneira ainda mais ágil e descomplicada.",
  "repeat_your_customer_clicks": "Repita o último pedido do seu cliente em apenas 2 cliques.",
  "cash_register_simply": "Abertura e fechamento de caixa com relatórios simplesmente fantásticos.",
  "gain_extra_speed": "Ganhe uma velocidade extra no atendimento das mesas.",
  "support_more_information": "A mensalidade do seu plano completo venceu e não identificamos o pagamento. Entre em contato com o suporte para mais informações",
  "dear_customer": "Prezado Cliente,",
  "have": "têm",
  "not_have": "não têm",
  "new_orders": "novos pedidos.",
  "go_to_orders": "Ir para pedidos",
  "general_settings": "Configurações Gerais",
  "need_help": "Precisando de Ajuda?",
  "you": "Você",
  "copied_clipboard": "Copiado para área de transferência",
  "copy_n": "Copiar",
  "browser_not_have_copy": "Seu navegador não possuí a opção de copiar",
  "cashback_status": "Status Cashback",
  "cashback_configuration": "Configuração Cashback",
  "loyalty": "Fidelidade",
  "percentage_of": "Porcentagem",
  "percentage_up": "PORCENTAGEM",
  "validity": "Validade",
  "days_n": "Dias",
  "in_days": "Em dias",
  "how_to_configure_cashback": "Como configurar o Cashback no WhatsMenu",
  "activate_cashback": "Ativar Cashback",
  "promotion_link": "Link de divulgação",
  "profile_information": "Informações do Perfil",
  "store_name": "Nome da Loja",
  "enter_store_name": "Digite o nome da Loja",
  "enter_slug": "Digite o seu slug",
  "contact_phone_number": "Telefone de Contato",
  "enter_contact_phone": "Digite o telefone de contato",
  "contact": "Contato",
  "message_phone_number_will": "Este telefone só ficará disponível para clientes que estiverem com pedidos em andamento.",
  "enter_store_description": "Digite a descrição de sua loja",
  "minimum_delivery_order": "Pedido Mínimo Entrega",
  "minimum_order_excluding_delivery": "Menor valor de um pedido, sem contar a taxa de entrega.",
  "minimum_order_pickup": "Pedido Mínimo Retirada no Local",
  "minimum_order_pickup_delivery": "Menor valor de um pedido, sem contar a taxa de entrega.",
  "preview_your_store": "Pré visualização da sua loja",
  "preview": "Pré Visualização",
  "open_n": "Aberto",
  "calculate": "Calcular",
  "store_color": "Cor da Loja",
  "wait_time": "Tempo de Espera",
  "establishment": "Estabelecimento",
  "store_layout": "Layout da Loja",
  "shipping": "Frete",
  "congratulations": "Parabéns",
  "message_few_steps_organized": "Em poucos passos você terá um atendimento ágil e organizado com o seu",
  "digital_menu": "Cardápio Digital",
  "basic_details_establishment": "Preencha agora os dados básicos do seu estabelecimento.",
  "filling_profile": "Preenchendo perfil",
  "restaurant_address": "Endereço do restaurante",
  "message_plan_not_include_delivery": "Seu plano atual não inclui a funcionalidade de Delivery ou de Encomendas/Agendamentos. Entre em contato com o suporte para mais Detalhes.",
  "closing_scheduled_time": "Fechamento fora do horário programado",
  "reopening_date": "Data de Reabertura",
  "time_zone": "Fuso Horário",
  "select_time_zone": "Selecione seu fuso horário",
  "now": "Agora",
  "add_business_hours": "Adicionar Horário de Funcionamento",
  "store": "Loja",
  "closed_a": "fechada",
  "open_a": "aberta",
  "monday": "Segunda",
  "tuesday": "Terça",
  "wednesday": "Quarta",
  "thursday": "Quinta",
  "friday": "Sexta",
  "saturday": "Sábado",
  "sunday": "Domingo",
  "delivery_fees": "Taxas de Entrega",
  "shipping_neighborhood": "Frete por bairro",
  "shipping_by_mi": "Frete por KM",
  "mile": "Quilômetro",
  "delivery_type_change_to": "Tipo de entrega alterado para",
  "loading": "Carregando...",
  "delivery_type": "Tipo de Entrega",
  "by_mile": "Por Quilômetro",
  "reset_fees": "Redefinir Taxas",
  "message_fee_deleted": "Se você alterar a forma de taxa todas as taxas atuais serão apagadas",
  "message_really_change_fee": "Deseja realmente alterar a forma de taxa",
  "by_neighborhood": "Por Bairro",
  "neighborhood_name": "Nome do Bairro",
  "neighborhood_cannot_duplicated": "O bairro não pode ser repetido",
  "to_be_confirmed": "A consultar",
  "neighborhood_added": "Bairro adicionado",
  "city_and_neighborhood_added": "Cidade e bairro adicionados",
  "neighborhood_deleted": "Bairro excluído",
  "city_deleted": "Cidade  excluída",
  "time_minutes": "Tempo em Minutos",
  "changes_made_successfully": "Alterações feitas com sucesso",
  "unexpected_try_again": "Algo inesperado aconteceu. Por favor tente novamente",
  "success": "Sucesso",
  "stripe_international_payments": "Pagamentos Internacionais",
  "stripe_international_payments_description": "Aceite cartões globais, Apple Pay e Google Pay com aprovação automática de pedidos.",
  "asaas_logo_alt": "Logo Asaas",
  "online_payment_automatic": "Pagamento Online - Automático",
  "message_avoid_fraud_errors": "Evite golpes, erros e atrasos no atendimento tendo que verificar comprovantes no app do banco.",
  "asaas_terms_use": "Termos de uso Banco Asaas",
  "complete_activation_account": "Atenção: conclua a ativação da sua conta",
  "acess_email": "Acesse o email",
  "message_open_asaas_email": "Abra o email do Asaas e clique no link para criar sua senha bancaria.",
  "message_sent_sms_token": "Enviamos o SMS com o token para",
  "account_creation_details": "Dados da Conta Criada",
  "branch": "Agência",
  "account_label": "Conta",
  "acess_asaas_account": "Acesse sua conta Asaas",
  "termis_of_use": "Termo de uso",
  "webhooks": "Webhooks",
  "webhook": "Webhook",
  "unable_fetch_webhook_status": "Não foi possível buscar os status dos webhooks",
  "webhook_updated_successfully": "Webhook atualizado com sucesso",
  "unable_update_webhook_status": "Não foi possível atualizar os status dos webhooks",
  "confirm_change": "Confirmar alteração",
  "webhook_confirm_message": "Você deseja {{action}} o webhook <b>{{name}}</b>?",
  "online_payment": "Pagamento Online",
  "payment_on_delivery_card": "Pagamento na Entrega - Maquininha",
  "payment_on_delivery": "Pagamento na Entrega",
  "automate_your_payments": "Automatize o recebimento das suas cobranças",
  "activate_this": "Ativar Este",
  "up_two_business_days": "Até 2 dias úteis",
  "acess_detailed_statements_asaas": "Obs. acesse o seu app Banco Asaas para extrato detalhado.",
  "enable_surcharge_discount": "Habilitar Acréscimo/Desconto",
  "disabled_o": "Desativado",
  "activated": "Ativado",
  "card_network": "Bandeira",
  "add_card_network": "Adicionar Bandeira",
  "key_type": "Tipo de Chave",
  "key": "Chave",
  "invalid_pix": "Pix inválido",
  "money": "Dinheiro",
  "pix": "Pix",
  "picpay": "PicPay",
  "credit_card": "Cartão de Crédito",
  "credit": "Crédito",
  "debit": "Débito",
  "meal_voucher": "Vale Refeição",
  "food_voucher": "Vale Alimentação",
  "month": "Mês",
  "year": "Ano",
  "january": "Janeiro",
  "february": "Fevereiro",
  "march": "Março",
  "april": "Abril",
  "may": "Maio",
  "june": "Junho",
  "july": "Julho",
  "august": "Agosto",
  "september": "Setembro",
  "october": "Outubro",
  "november": "Novembro",
  "december": "Dezembro",
  "search_for": "Buscar por",
  "summary": "Resumo",
  "detailed_summary": "Resumo Detalhado",
  "number_orders": "Quantidade de Pedidos",
  "no_fees": "Sem Taxas",
  "no_deliverys": "Sem Entregas",
  "deliverys": "Entregas",
  "number_deliveries": "Quantidade de Entregas",
  "total_sales_and_coupons": "Total de vendas do período - Total de cupons (Desconsiderando taxas/descontos de pagamento)",
  "products_total": "Acumulado de todos os produtos",
  "tax_delivery_total": "Acumulado de todas as taxas de entrega",
  "period": "Período",
  "total_period": "Total do Período",
  "notes": "Notas",
  "total_canceled": "Total cancelado",
  "number_canceled_orders": "Quantidade de Pedidos Cancelados",
  "total_fees": "Total de taxas",
  "no_fees_period": "Sem taxas nesse período",
  "fixed_amount": "VALOR FIXO",
  "fixed_amount_n": "Valor Fixo",
  "payment_methods_n": "Formas de Pagamento",
  "waitstaff": "Garçons",
  "creation_date": "Data Criação",
  "daily_report": "Relatório Diário",
  "monthly_report": "Relatório Mensal",
  "delivery_registration": "Cadastro de Entregadores",
  "error_deleting_delivery_person": "Erro ao excluir motoboy",
  "error_pausing_activating": "Erro ao pausar/ativar motoboy",
  "error_editing_delivery_person": "Error ao editar entregador",
  "delivery_person_name": "Nome do Entregador",
  "enter_delivery_person": "Digite o nome do Entregador",
  "enter_whatsapp_number": "Digite número do WhatsApp",
  "registered_delivery": "Entregadores Cadastrados",
  "fill_all_fields": "Por favor, preencha todos os campos.",
  "coupon_management": "Gestão de Cupons",
  "coupon_code": "Código do Cupom",
  "coupon_already_exists": "Este cupom já existe",
  "coupon_invalid_chars": "Caracteres especiais não são permitidos",
  "coupon_allowed_chars_hint": "Apenas letras, números, hífen (-) e sublinhado (_)",
  "coupon_code_valid": "Código disponível",
  "offer_type": "Tipo de Oferta",
  "coupon_type": "Tipo de Cupom",
  "first_purchase": "Primeira Compra",
  "discount_amount": "Valor de Desconto",
  "minimum_amount": "Valor Mínimo",
  "code": "Código",
  "unable_create_the_coupon": "Não foi possivel criar o cupom",
  "coupon_not_created": "Cupom não criado.",
  "status_coupon": "Status Cupom",
  "actives": "ativos",
  "for_orders": "para pedidos",
  "inactive": "desativados",
  "successfully_deleted": "excluído com sucesso",
  "delete_coupon": "excluído com sucesso",
  "business_offer_deliveries": "O seu negócio faz entregas",
  "customer_pick_up_order_onsite": "O cliente pode retirar o pedido no local",
  "cash_register": "Caixa",
  "active_cash_management": "Ativar gerenciamento de caixa",
  "message_currently_open_cash": "Você tem caixas abertos no momento. Por favor, os encerre no",
  "before_register_management": "antes de alterar o gerenciamento de caixas",
  "customers": "Clientes",
  "display_date_birth": "Exibir Data de Nascimento",
  "require_date_birth": "Obrigar data de nascimento",
  "default_texts": "Textos Padrões",
  "changing_default_text_observations": "Alterando texto padrão de observações",
  "product_note": "Observação Produto",
  "example_no_mayonnaise": "Ex.: Sem maionese, sem salada, etc...",
  "pizza_note": "Observação Pizza",
  "leave_any_note_product_here": "Deixe aqui qualquer observação no produto.",
  "message_client": "Olá [NOME], Tudo Bem?",
  "status_received": "Status Recebido",
  "you_order_production": "[NOME] seu pedido já está em produção!",
  "status_delivering": "Status Entregando",
  "yay_order_already_way": "Obaaa, [NOME] seu pedido já está a caminho!",
  "status_pickup": "Status Retirar",
  "finished": "Finalizado",
  "order_ready_pickup": "Obaaa, [NOME] seu pedido já está pronto para retirada!",
  "order_status_pos": "Status pedido no PDV",
  "order_successfully_placed": "[NOME] pedido efetuado com sucesso, acompanhe o status do seu pedido abaixo!",
  "greeting_message": "Mensagem de saudação",
  "message_hello": "Olá [NOME]!",
  "welcome_to": "Seja bem vindo ao",
  "check_menu_order": "Veja o nosso cardápio para fazer seu pedido",
  "exclusive_offers": "Ofertas exclusivas para pedidos no link",
  "team": "Equipe",
  "use_a_printer": "Usar impressora",
  "group_order_printing": "Agrupar itens de pedidos para impressão",
  "print_test": "Teste Impressão",
  "test_print": "Testar Impressão",
  "printer_driver": "Driver de Impressão",
  "others": "Outros",
  "printing_app": "Aplicativo de Impressão",
  "print_width": "Largura da Impressão",
  "letters": "Letras",
  "small": "Pequena",
  "large": "Grande",
  "copies": "Cópias",
  "necessary_whatsmenu_android_installed": "Necessário ter o aplicativo Whatsmenu Impressora 2.0 instalado (Somente Android)",
  "pizza_options": "Opções de Pizzas",
  "assign_price_most_expensive": "Atribuir valor da mais cara",
  "different_crusts_each_flavor": "Permitir bordas para cada sabor",
  "allow_each_flavor": "Permitir complementos para cada sabor",
  "stock_options": "Opções de Estoque",
  "display_out_of_stock_product_addons": "Exibir status de 'esgotado' em produtos e complementos pausados",
  "hide_ssn_receipt": "Ocultar opção de CPF/CNPJ na nota",
  "description_top_product_page": "Exibir foto e descrição do produto no topo da página do produto",
  "activate_catalog_mode_delivery": "Ativar modo catálogo no delivery - Não será possível finalizar a compra, apenas visualizar os produtos.",
  "activate_catalog_the_table": "Ativar modo catálogo na mesa - Não será possível finalizar a compra, apenas visualizar os produtos.",
  "automations": "Automações",
  "ignore_products_and_categories_availability": "Ignorar disponibilidade de horário do produto e da categoria no PDV",
  "send_status_page_pos_customer": "Deseja enviar a página de Status no PDV para o cliente",
  "only_indentification": "Apenas a identificação",
  "label": "Rótulo",
  "saving": "Salvando...",
  "are_no_pending_changes": "Não há alterações pendentes",
  "no_changes": "Sem Alterações",
  "saved": "Salvo",
  "saved_successfully": "Salvo com sucesso.",
  "order_date": "Data Pedido",
  "tomorrow": "Amanhã",
  "today": "Hoje",
  "deliver_pickup": "Entregando/Retirada",
  "delivery_e": "Entrega Delivery",
  "closed_o": "Fechado",
  "receive_orders_from": "Para receber pedidos de",
  "enable_options_the_settings_for": "habilite a opções nas configurações de",
  "printed": "Impr",
  "are_no_orders_moment": "Não há pedidos até o momento",
  "hours": "Horários",
  "review_delivery_hours": "Por favor, revise o horário de entregas.",
  "changes_saved": "Alterações salvas com sucesso.",
  "not_saved": "Não Salvo",
  "unable_save_check_connection": "Não foi possível salvar as alterações, vefique a sua conexão.",
  "no_changes_to_save": "Não há alterações para serem salvas",
  "delivery_type_activated": "É necessário ter no mínimo um tipo de entrega ativado",
  "pickups": "Retiradas",
  "deliveries_pickups": "Entregas/Retiradas",
  "delivery_types_must_one_activated": "Tipos de entregas precisam ter no mínimo um ativado",
  "activate_orders": "Ativar Encomendas",
  "delivery_scheduling": "Agendamentos de entregas",
  "order_settings": "Configurações de Encomendas",
  "pickup_onsite": "Retirar no Local",
  "allow_onesite_pickups": "Permitir Retiradas no Local",
  "allow_delivery_services": "Permitir Entregas Delivery",
  "make_available": "Disponibilizar",
  "starting_from": "a partir de",
  "allow": "Permitir",
  "for_day": "para o dia",
  "within": "em até",
  "group": "Agrupar",
  "every": "a cada",
  "preparationTime": "Tempo de Preparação",
  "minutes": "Minutos",
  "max_of": "Máx. de",
  "per_day_from": "por dia de 1 a 1000",
  "per_hour": "por horário",
  "display_menu_as": "Exibir no cardápio como",
  "minimum_for_delivery": "Mínimo para entrega",
  "minimum_for_pickup": "Mínimo para retirada",
  "register_order_cash_register": "Registrar Pedidos no caixa",
  "on_day_ordered": "No dia em que foi pedido",
  "on_delivery_day": "No dia de entrega",
  "availability_of": "Disponibilidade de",
  "dates_not_be_available": "Datas que você não fará",
  "select_special_dates": "Selecione as datas especiais que você não não fará",
  "select_a_date": "Selecione uma data",
  "defined_dates": "Datas Definidas",
  "remove": "Remover",
  "values": "Valores",
  "minimum_order_for_pickup": "Pedido Mínimo Retirar no Local",
  "table_name_already_exists": "Ja existe uma mesa com esse nome",
  "create_table": "Criar Mesa",
  "enter_valid_name": "Por favor insira um nome válido",
  "new_table": "Nova mesa",
  "creating_table": "Criando mesa",
  "using_table_system": "Utilizando sistema de mesas",
  "table_name": "Nome da Mesa",
  "cancel": "Cancelar",
  "available": "Disponível",
  "occupied": "Ocupada",
  "paused_a": "Pausada",
  "selected": "Selecionada",
  "you_haven_registered_tables": "Você ainda não cadastrou nenhuma mesa",
  "how_close_entire_table": "Como encerrar a mesa total",
  "how_close_individual": "Como encerrar comandas  individuais",
  "table_settings": "Configurações da Mesa",
  "fee_name_already_exists": "Já existe uma taxa com este nome.",
  "fee_name_cannot_empty": "Nome da taxa não pode ser vázio.",
  "enter_value_greater_than": "Insira um valor maior que",
  "add_fee": "Adicionar Taxa",
  "created_successfully_a": "criada com sucesso",
  "activate_fee": "Ativar Taxa",
  "automatic_charge": "Cobrança Automática",
  "changed_successfully": "alterado com sucesso",
  "delete_fee": "Excluir Taxa",
  "deleted_successfuly": "excluído com sucesso",
  "register_waitstaff": "Registrar Garçom",
  "update_waitstaff": "Atualizar Garçom",
  "create_waitstaff": "Criar Garçom",
  "edit_waitstaff": "Editar Garçom",
  "delete_waitstaff": "Deletar Garçom",
  "deleted_successfully_o": "excluido com sucesso",
  "restrict_menu": "Restringir Cardápio",
  "unable_retrieve_menu_information": "Não foi possivel obter informações do cardápio no momento, tente novamente",
  "creating_fees": "Criando taxas",
  "fee_name": "Nome da taxa",
  "fee_already_exists": "Esta taxa já existe",
  "type_charge": "Tipo de Cobrança",
  "enter_number_greater_than": "Insira um número maior que",
  "charge_automatically": "Cobrar Automaticamente",
  "deactive": "Desativar",
  "registering_waitstaff": "Cadastrando garçom",
  "placing_order_waiter": "Fazendo um pedido como garçom",
  "placing_pizza_order_waiter": "Fazendo um pedido de pizza como garçom",
  "waitstaff_name": "Nome do Garçom",
  "permission": "Permissão",
  "manager": "Gerente",
  "allow_orders": "Permitir Pedidos",
  "register": "Registrar",
  "categories": "Categorias",
  "select_categories_waiter_permitted": "Selecione quais categorias o garçom terá permissão para realizar pedidos",
  "call_waitstaff": "Chamar Garçom",
  "keep_waitstaff_logged": "Manter garçom logado",
  "change_password": "Alterar senha",
  "change_table": "Alterar Mesa",
  "enter_valid_name_different_current": "Por favor insira um nome válido ou diferente do nome atual",
  "delete_table": "Excluir Mesa",
  "activated_a": "ativada",
  "pause_table": "Pausar Mesa",
  "not_possible_pause_table_open": "Não é possivel pausar mesas com comandas abertas",
  "table_options_up": "OPÇÕES DE MESA",
  "points": "Pontos",
  "settings_up": "CONFIGURAÇÕES",
  "background": "Fundo",
  "resources": "Recursos",
  "register_cashier": "Registrar Operador de Caixa",
  "registering_operator": "Cadastrando operador",
  "placing_order_operator": "Fazendo um pedido como operador",
  "operator_name": "Nome do Operador",
  "operators": "Operadores",
  "box_settings": "Configurações de Caixa",
  "delete_operator": "Deletar Operador",
  "edit_operator": "Editar Operador",
  "create_operator": "Criar Operador",
  "my_name_is": "Meu nome é",
  "update_operator": "Atualizar Operador",
  "register_operator": "Registrar Operador",
  "there_failure_transaction": "Houve uma falha na transação",
  "change_card": "Alterar Cartão",
  "unable_change_payment_card": "Não foi possível alterar o cartão de cobrança",
  "redirecting_payment_page": "Redirecionando para Pagina de Pagamento",
  "difficulty_generating_payment_screen": "Estamos com dificuldade para gerar a tela de pagamento, tente novamente",
  "payment_gateway": "Gateway de Pagamento",
  "no_payment_gateway_found": "Não encontramos nenhum gateway de pagamento",
  "select_option": "Selecione uma opção",
  "subscription": "Assinatura",
  "adding_your_subscription": "Estamos adicionando sua assinatura.",
  "failure_adding_your_subscription": "Houve uma falha ao adicionar sua assinatura",
  "subscription_created_successfully": "Sua assinatura foi criada com sucesso",
  "failure_processing_try_again": "Houve uma falha no processamento tente novamente",
  "ongoing_monthly_invoice": "Existe uma fatura mensal em andamento.",
  "subscription_canceled": "Sua assinatura esta cancelada",
  "required": "Obrigatório",
  "required_complement_all_items_paused": "Não dá para salvar: em \"{{name}}\", todos os itens estão pausados, mas o complemento está como obrigatório. Ative pelo menos um item ou desmarque \"Complemento obrigatório\".",
  "additional": "Adicional",
  "monthly": "Mensal",
  "annual": "Anual",
  "semiannual": "Semestral",
  "monthly_payment": "Mensalidade no cartão",
  "add_registration_service": "Adicionar serviço de cadastro",
  "with_printer": "Com impressora",
  "message_failure_payment_card": "Houve uma falha no processamento do pagamento verifique os dados e certifique-se que existe limite disponível em seu cartão",
  "payment_completed_successfully": "Pagamento efetuado com sucesso, iremos recarregar a pagina.",
  "outstanding_invoices": "Faturas em Aberto",
  "in_progress": "Em Andamento",
  "pay": "Pagar",
  "view_items": "Ver Itens",
  "cart": "Carrinho",
  "check_items": "Confira os itens",
  "start_registration": "Começar Cadastro",
  "proceeding_whatsmenu_contact": "Ao prosseguir, aceito que o WhatsMenu entre em contato comigo por telefone, e-mail ou WhatsApp (incluindo mensagens automáticas para fins comerciais).",
  "owner_name": "Nome do dono do estabelecimento",
  "there_no_items_moment": "Não há itens no momento",
  "unique": "Única",
  "hello": "Olá",
  "after_payment_confirmation": "após a confirmação de pagamento você será redirecionado a página será recarregada.",
  "proceed_payment": "Continuar para Pagamento",
  "pending_pay": "Pagamento Pendente",
  "refunded": "Estornado",
  "under_review": "Em Analise",
  "awaiting_confirmation": "Aguardando Confirmação",
  "your_monthly_every_day": "Sua Mensalidade vence todo dia",
  "each_month": "de cada mês",
  "services": "Serviços",
  "plan": "Plano",
  "generate_invoice": "Gerar Boleto",
  "view_invoice": "Ver Fatura",
  "no_outstandigin_invoices_moment": "Não há faturas em aberto no momento.",
  "paid_invoice_history": "Histórico de Faturas Pagas",
  "detail_table": "Detalhar Mesa",
  "order_results": "Resultados Pedido",
  "displaying_orders_date_from": "Exibindo pedidos por data de",
  "domain_registered_dns_registration": "Domínio registrado com sucesso!, entre em contato com o suporte para solicitar o cadastro de registro de DNS",
  "domain_registered": "Domínio registrado com sucesso!",
  "domain_already_registered": "Esse dominio ja esta registrado",
  "enter_valid_domain": "Por favor insira um domínio válido",
  "invalid_domain": "Domínio Inválido",
  "domain_not_valid": "Este domínio não é válido por favor insira um dominio válido",
  "domain_successfully_deleted": "Domínio excluído com sucesso",
  "delete_domain": "Excluir Domínio",
  "default_domain_successfully_changed": "Domínio padrão alterado com sucesso",
  "dns_entry": "Entrada de DNS",
  "dns_entry_successfully": "Entrada de DNS excluída com sucesso",
  "domain_settings": "Configurações de Domínios",
  "after_registering_domain": "Após o cadastro do domínio será necessário realizar o apontamento para esses servidores",
  "domain": "Domínio",
  "domain_information": "Dados do Domínio",
  "registered_domains": "Domínios Cadastrados",
  "default_domain_cannot_deleted": "Domínio padrão não pode ser excluído. Por favor entre em contato com o suporte",
  "domain_com": "dominio.com",
  "default_domain": "Domínio padrão",
  "monthly_orders_report": "Relatório de Pedidos Mensais",
  "monthlys": "Mensais",
  "daily_orders_report": "Relatório de Pedidos Diários",
  "box_closures": "Encerramentos de Caixas",
  "box_report": "Relatório de Caixas",
  "customer_report_v2": "Relatório de Clientes",
  "best_selling_report": "Relatório de Mais Vendidos",
  "best_sellers_v2": "Os Mais Vendidos",
  "click_here_view_details": "Clique aqui para ver o detalhado",
  "summary_last_months": "Resumo dos últimos 12 meses",
  "summary_last_days": "Resumo dos últimos 30 dias",
  "financial": "Financeiro",
  "ph": "Tel",
  "dailys": "Diários",
  "opening": "Abertura",
  "export_spreadsheet": "Exportar para planilha",
  "creation": "Criação",
  "delivery_m": "entrega",
  "ready": "Pronto",
  "spreadsheet": "Planilha",
  "successfully_generated": "gerada com sucesso",
  "no_orders_found": "Nenhum pedido encontrado",
  "empty": "Vazio",
  "outputs": "Saidas",
  "daily": "Diário",
  "motoboys_daily": "Diária",
  "motoboys_dailys": "Diárias",
  "deliveries_statement": "Extrato de Entregas",
  "enter_daily_amount": "Digite o valor da diária",
  "delivery_driver_signature": "Assinatura do Entregador",
  "line_signature": "______________________________________",
  "invisible_line": "                                      ",
  "operators_boxes": "Operadadores caixas",
  "box_listing": "Listagem de Caixas",
  "opening_balance": "Saldo inicial",
  "opening_date": "Data de Abertura",
  "closing_date": "Data de encerramento",
  "box_closure": "Encerramento de Caixas",
  "paid_a": "Paga",
  "view_menu": "Ver Cardápio",
  "coin_t": "Moeda",
  "snack": "Vale Refeição",
  "food": "Vale Alimentação",
  "order_printed_please_wait_finish": "Um pedido esta sendo impresso, aguarde a finalização",
  "password_settings": "Configurações de senha",
  "access": "acesso",
  "security": "segurança",
  "incorrect_current_password": "Senha atual incorreta",
  "register_financial_password": "Cadastre uma senha financeira",
  "register_password": "Cadastre senha",
  "change_financial_password": "Alterar Senha Financeira",
  "register_password_financial": "Cadastrar Senha Financeira",
  "current_password": "Senha Atual",
  "new_password": "Nova Senha",
  "confirm_password": "Confirme a Senha",
  "change_access_password": "Alterar Senha de Acesso",
  "recover_financial_password": "Recuperar Senha Financeira",
  "confirm_new_password": "Confirmar Nova Senha",
  "authentication_failure": "Falha na autenticação",
  "password_recovery_token": "Token de recuperação de senha expirado ou ínvalido",
  "use_printer": "Usar Impressora",
  "enable_stock_control": "Habilitar Controle de Estoque",
  "stock_control": "Controle de Estoque",
  "layout_options": "Opções de Layout",
  "tax_settings": "Configurações NFe",
  "edit_company": "Editar Empresa",
  "add_company": "Adicionar Empresa",
  "configure_emission": "Configurar Emissão",
  "company": "Empresa",
  "natural_person": "Pessoa Física",
  "company_name": "Razão Social",
  "certificate": "e-CNPJ A1",
  "attach_certificate": "Anexar Certificado Modelo A1",
  "identification": "Identificação",
  "responsable": "Responsável",
  "accounting": "Contabilidade",
  "tokens": "tokens",
  "zelle": "Zelle",
  "twint": "Twint",
  "tax_documents": "Documentos Fiscais",
  "attach_company_logo": "Anexar logo da empresa",
  "trade_name": "Nome Fantasia",
  "state_registration": "Inscricão Estadual",
  "municipal_registration": "Inscricão Municipal",
  "tax_regime": "Regime Tributário",
  "select_an_option": "Selecione uma opção",
  "simple_national": "Simples Nacional",
  "Excess_gross_revenue_sublimit": "Excesso de sublimite de receita bruta",
  "normal_regime": "Regime Normal",
  "email": "Email",
  "ein": "CNPJ",
  "street": "Rua",
  "municipality": "Município",
  "fu": "UF",
  "responsible_name": "Nome do Responsável",
  "responsible_ssn": "CPF do Responsável",
  "approval_token": "Token de Homologação",
  "production_token": "Token de Produção",
  "approval": "Homologação",
  "series": "Série",
  "next_number": "Proximo número",
  "id_approval_token": "ID Token de Homol.",
  "security_code_approval": "CSC Homol.",
  "production": "Produção",
  "id_production_token": "ID Token",
  "security_code_production": "CSC",
  "advanced_settings": "Configurações Avançadas",
  "electronic_consumer_fiscal_note": "NFCe",
  "enable_offline_contingency": "Habilita contingência offline",
  "all_documents": "Todos os Documentos",
  "send_email_to_recipient": "Enviar email ao destinatário",
  "discriminate_taxes": "Discriminar Impostos",
  "electronic_fiscal_note": "NFe",
  "show": "Mostrar",
  "auxiliary_document_for_the_electronic_fiscal_notes": "DANFSe",
  "show_badge_focus_efn_on_adefn": "Mostrar badge Focus NFe na DANFSe",
  "emission_ecfn": "Emissão NFCe",
  "whenever_necessary_you_can_manually_issue_in_addition_to_the_defined_standard": "sempre que necessário você poderá emitir manualmente alem do padrão definido",
  "set_defaults_for_automatic_issuance_of_your_fiscal_notes": "Defina padrões para emissão automática de suas notas fiscais",
  "daily_average": "Media Diária",
  "credit_machine": "Crédito Maquina",
  "credit_online": "Crédito Online",
  "debit_machine": "Débito Maquina",
  "debit_online": "Débito Online",
  "dont_miss_deadlines": "Não perca prazos",
  "we_will_send_the_fiscal_closing": "Enviaremos mensalmente o fechamento fiscal (XML) para sua contabilidade",
  "accountant_email": "Email do Contador",
  "additional_service": "Serviço adicional",
  "gratis": "Gratis",
  "for_shopkeeper": "para lojista",
  "WM": "WhatsMenu",
  "plan_change": "Alteraçãoo do Plano",
  "current_plan": "Plano Atual",
  "plan_expiration": "Vencimento do Plano",
  "change_plan": "Alterar Plano",
  "security_password_registered": "Senha de segurança cadastrada com sucesso",
  "with": "com",
  "consult": "Consultar",
  "link_for_order_status": "Link para o status do pedido",
  "chosen_date_earlier_current_date": "A data escolhida é menor que a data atual, favor escolher uma data maior.",
  "check_the_cvv": "Verifique o CVV",
  "check_card_details": "Verifique os dados do cartão",
  "check_billing_address": "Verifique o endereço de cobrança",
  "check_card_expiration_date": "Verifique a validade do cartão",
  "check_card_number": "Verifique o número do cartão",
  "check_security_code": "Verifique o código de segurança",
  "check_zip_code": "Verifique o CEP",
  "unable_register_your_order_try_again": "Não foi possível registrar seu pedido tente novamente",
  "system_identified_you_are_outside": "O sistema identificou que você está fora da nossa área de cobertura, tente concluir o seu pedido novamente",
  "swiss_french": "Franco Suiço (Fr.)",
  "swiss_french_chf": "Franco Suiço",
  "jamaican_dollar": "Dólar jamaicano",
  "mexican_peso": "Mexican Peso",
  "eastern_caribbean_dollar": "Eastern Caribbean Dollar",
  "integrations": "Integrações",
  "stripe": "Stripe",
  "stripe_invalid_api_key": "Informe uma API key válida.",
  "stripe_test_key_not_allowed": "Não é permitido usar chaves de teste. Por favor, use uma chave de produção (sk_live_).",
  "stripe_integration_saved_successfully": "Integração Stripe salva com sucesso.",
  "stripe_integration_save_error": "Não foi possível salvar a integração. Tente novamente.",
  "stripe_logo_alt": "Logo Stripe",
  "stripe_description_1": "A Stripe é uma plataforma de infraestrutura financeira global que permite restaurantes de todos os tamanhos aceitarem pagamentos online no mundo todo.",
  "stripe_description_2": "Crie uma conta e comece a aceitar pagamentos multimoedas, sem contratos nem dados bancários.",
  "stripe_international_currencies": "Moedas internacionais",
  "stripe_currency_flag_alt": "Bandeira {{code}}",
  "stripe_connect_account": "Integrar minha conta Stripe",
  "stripe_api_key_label": "API Key da Stripe",
  "stripe_api_key_placeholder": "sk_live_...",
  "stripe_currency_cad": "Dólar canadense",
  "stripe_currency_eur": "Euro",
  "stripe_currency_mxn": "Peso mexicano",
  "stripe_currency_aud": "Dólar australiano",
  "stripe_currency_gbp": "Libra esterlina",
  "stripe_currency_nzd": "Dólar neozelandês",
  "stripe_currency_cnh": "Renminbi chinês",
  "stripe_currency_jpy": "Iene japonês",
  "stripe_currency_usd": "Dólar americano",
  "stripe_currency_chf": "Franco suíço",
  "stripe_currency_sek": "Coroa sueca",
  "stripe_currency_hkd": "Dólar de Hong Kong",
  "stripe_currency_try": "Lira turca",
  "stripe_currency_krw": "Won sul-coreano",
  "stripe_digital_wallets_title": "Google Pay e Apple Pay",
  "stripe_digital_wallets_description": "A Stripe também aceita pagamentos via Google Pay e Apple Pay, oferecendo aos seus clientes uma experiência de checkout rápida e segura.",
  "stripe_fees_title": "Repasse de taxas do Stripe",
  "stripe_fees_description": "Configure taxas adicionais que serão cobradas automaticamente quando o cliente pagar via Stripe.",
  "stripe_fees_enable": "Cobrar taxas do Stripe",
  "stripe_fees_enable_description": "Quando ativado, as taxas configuradas serão adicionadas ao valor total do pedido no checkout do Stripe.",
  "stripe_fees_fixed_label": "Taxa fixa",
  "stripe_fees_fixed_placeholder": "0.00",
  "stripe_fees_percentage_label": "Taxa percentual (%)",
  "stripe_fees_percentage_placeholder": "0.00",
  "stripe_fee": "Taxa Stripe",
  "online_payment_s": "Pagamentos Online",
  "online_payment_description": "Evite golpes, erros e atrasos tendo que verificar comprovantes no app do banco, o pedido chega no painel e o pagamento com segurança direto na sua conta.",
  "fiscal_note_issuer": "Emissor de NFe e NFCe",
  "fiscal_note_issuer_description": "Chega de perder tempo lançando notas fiscais na mão, Defina automações e configure limites de acordo com o seu enquadramento CNPJ.",
  "grove_nfe_description": "Emissão e Gestão Automática de Notas Fiscais",
  "automation_of_nfe": "Automação NFC-e",
  "certificate_password": "Senha Do Seu Certificado Certificado Modelo A1",
  "set_the_environment": "Defina o ambiente",
  "origin": "Origem",
  "not_received": "Não recebido",
  "marketing_and_sales": "Marketing e Vendas",
  "we_integrate_your_store": "Integramos sua loja as maiores ferramentas de marketing e vendas do mercado, atraia mais clientes e venda muito mais com menos trabalho.",
  "own_website": "Site Próprio",
  "disponibility": "Disponibilidade",
  "please_enter_valid_name": "Por favor insira um nome válido!",
  "image_up": "Imagem com até 8mb (resolução recomendada de 600x450)",
  "share": "Compartilhar",
  "fill_all_required": "Preencha todos os campos obrigatórios",
  "billing": "Faturamento",
  "result_orders": "Resultado Pedidos",
  "viewing_orders_by_date": "Exibindo pedidos por data de",
  "enable_original_image_size": "Ativar tamanho original da imagem",
  "cashback": "Cashback",
  "no_register": "Sem cadastro",
  "load_complements_wait": "Carregando complementos, por favor aguarde",
  "deactivated_delivery": "Desativar Delivery",
  "hide_unity": "Desabilitar quantidade",
  "Delivery_options": "Opções do Delivery",
  "Profile_options": "Opções do Perfil",
  "catalog_mode": "Modo de Catálogo",
  "status_order": "Status do Pedido",
  "completed": "Concluído",
  "slug": "Slug",
  "clone_categories": "Clonar Categorias",
  "clone": "Clonar",
  "no_change_needed": "Não precisa de troco",
  "serivce_fee": "Taxa de Serviço",
  "customer_delivery_address": "Endereço de Entrega do Cliente",
  "not_informed": "Não informado",
  "route_up": "ROTA",
  "payments_in": "Pagamentos em",
  "the_order_is_now_ready": "o pedido já está pronto para ser retirado! Aqui está o contato do cliente",
  "if_you_need": "caso precise",
  "reference": "Referência",
  "pickup_the_location": "Vou retirar no local",
  "table_request": "Pedido mesa",
  "possible": "Possível",
  "the_date_of_your_delivery": "A data da sua entrega é",
  "sounds_notification": "Som de notificação de pedidos",
  "play_sound_delivery": "Ativar som de pedidos de delivery",
  "play_sound_eat_on_site": "Ativar som de pedidos de comer no local",
  "play_sound_table": "Ativar som de pedidos de mesa",
  "play_sound_package": "Ativar som de pedidos de encomenda",
  "closing": "Fechamento",
  "mbway": "MBWay",
  "spin": "Spin",
  "unable_to_read": "Não foi possível ler a sua localização, por favor verifique se os serviços de localização não estão bloqueados.",
  "address_covarage_area": "O seu endereço está fora da nossa área de cobertura!",
  "register_open_24": "Há um caixa aberto há mais de 24 horas e será fechado.",
  "table_desactived": "Desculpe, esta mesa está atualmente desativada.",
  "moment_table_not_avaible": "No momento, esta mesa não está disponível para novos pedidos.",
  "table_not_avaible_new_orders": "No momento, esta mesa não está disponível para novos pedidos.",
  "order_already_been_completed": "O pedido anterior já foi concluído. Ainda está no restaurante ou gostaria de fazer um novo pedido para entrega?",
  "at_the_table": "Estou na mesa",
  "deliver_order": "Entregar pedido",
  "not_belong_this_table": "Este pedido não pertence a esta mesa.",
  "store_closed": "LOJA FECHADA!",
  "not_minimum_value": "O seu pedido não atingiu o valor mínimo de",
  "failed_validate_coupon": "Falha ao validar o cupão, por favor verifique a sua ligação!",
  "amount_not_include_delivery_fee": "Este valor total não inclui a taxa de entrega.",
  "coupon_used_starting_from": "Este cupão só pode ser utilizado para compras a partir de",
  "closed_delivery": "FECHADO PARA ENTREGA",
  "unable_create_customer": "Não foi possível criar o cliente. Por favor, tente novamente.",
  "selected_date_earlier_choose_later_date": "A data selecionada é anterior à data atual, por favor escolha uma data posterior.",
  "try_again_moment": "Algo inesperado aconteceu, por favor tente novamente em um momento.",
  "error_generate_qrcode": "Não foi possível gerar o QR Code. Por favor, tente novamente.",
  "payment_not_detected": "Pagamento não detectado. Por favor, verifique o seu aplicativo bancário.",
  "reloaded_page_message": "A página precisa ser recarregada!",
  "name_and_last_name_and_phone_required": "Nome, Sobrenome e telefone são obrigatórios",
  "enter_your_details": "Insira os seus dados",
  "enter_your_name": "Insira o seu nome",
  "enter_your_whatsapp": "Insira o seu Whatsapp",
  "enter_your_date_of_birth": "Insira a sua data de nascimento",
  "review_change_amount": "Revise o Valor do Troco!",
  "no_internet_connection": "Sem ligação à Internet",
  "ifood_portal_orders": "Motoboys Nuvem terceirizados via ifood",
  "disconnect_account": "Desconectar Conta Asaas",
  "cancel_edits": "Cancelar Edição",
  "option": "Opção",
  "toMiles": true,
  "Nenhum garçom ativo": "Ver Cardápio",
  "check_code": "Verifique o NPA",
  "enter_your_cpf": "Insira o seu CPF",
  "print_cash_report": "Imprimir Relatório de Caixa",
  "cashier_open": "Caixa Aberto",
  "product_type": "Tipo de Produto",
  "bulk": "Granel",
  "unit": "Unidade",
  "select_unit_measurement": "Selecione a unidade de medida",
  "kg_value": "Valor do Kilo",
  "l_value": "Valor do Litro",
  "barcode": "Código de Barras",
  "product_code": "Código do Produto",
  "no_product_code": "Sem Código",
  "product_code_abbreviation": "Cód. Produto",
  "product_code_already_exists": "Já existe um produto cadastrado com este código.",
  "pizza_product_code_already_exists": "Não foi possível salvar: já existe um produto ou tamanho de pizza com este código.",
  "volume": "Volume",
  "weight": "Peso",
  "select_product_will_be_sold": "Selecione se o produto será vendido como unidade ou a granel",
  "automatic_confirmation": "Confirmação automática",
  "manual_confirmation": "Confirmação manual",
  "unit_value": "Valor Unitário",
  "alter_value": "Alteração de valor",
  "open_for_appointments": "Aberto para agendamentos",
  "closed_for_appointments": "Fechado para agendamentos",
  "open_for_package": "Aberto para encomendas",
  "closed_for_package": "Fechado para encomendas",
  "cashback_why_better": "Por que o cashback supera promoções tradicionais e anúncios em portais",
  "cashback_money_attractive": "Dinheiro é mais atraente que pontos",
  "cashback_defined_validity": "Validade definida",
  "cashback_controlled_cost": "Custo controlado",
  "cashback_total_automation": "Automatização total",
  "cashback_rewards_now": "O cashback recompensa o agora. O cliente volta porque sente que já ganhou e não pode perder o dinheiro.",
  "cashback_growth_impact": "Crescimento e Impacto Real no Ticket Médio e Frequência",
  "cashback_how_to_activate": "COMO ATIVAR ESSE RECURSO:",
  "cashback_set_percentage": "Defina o percentual",
  "cashback_choose_validity": "Escolha a validade",
  "cashback_activate_save": "Ative e salve",
  "whatsMenuPro": {
    "this_app_is_better_than": "Este APP é melhor do que funcionários, seja na loja ou para entrega, toda a gestão agora é automatizada!",
    "waiter_app_delivery": "APP DE GARÇOM, ROTA DE ENTREGA E MUITO MAIS.",
    "yes_i_want": "SIM, QUERO MAIS INFORMAÇÕES",
    "i_want_information": "QUERO INFORMAÇÕES!",
    "aprroved_by": "Aprovado por mais de",
    "restaurants_worldwide": "restaurantes no mundo todo",
    "more_professionalism": "Mais profissionalismo",
    "more_clients_sales": "Mais clientes e mais vendas...",
    "whatsMenuPro_transform_small": "O WhatsMenu.PRO transforma pequenos restaurantes em poderosas máquinas de vendas:",
    "receive_orders_auto": "Receba pedidos automaticamente sem precisar interagir com os clientes.",
    "customers_will_not": "Os clientes não precisarão mais esperar pelo atendente.",
    "no_extra_labor": "Nenhuma mão de obra extra necessária para receber pedidos.",
    "automatic_priting": "Impressão automática de pedidos.",
    "never_lose_order": "Nunca mais perca um pedido.",
    "reduce_to_zero": "Reduce order errors to zero.",
    "increase_the_average": "Aumente o ticket médio e a frequência de compras.",
    "control_everything": "Controle tudo automaticamente pelo celular ou computador.",
    "the_features": "Os recursos que você receberá.",
    "the_most_complet": "A plataforma de restaurantes mais completa e poderosa:",
    "virtual_attendant": "Atendente Virtual",
    "catalog_mode": "Modo Catálogo",
    "orders_delivery_scheduling": "Pedidos e Agendamento de Entregas",
    "counter_orders": "Pedidos no Balcão",
    "order_manager": "Gerenciador de Pedidos",
    "pos_point_of_sale": "PDV - Ponto de Venda",
    "reports_customers": "Relatórios: Clientes, Produtos, Receita, Estoque",
    "qr_code_table_delivery": "QR Code para Mesa, Entrega e Balcão",
    "free_website": "Site Profissional Grátis",
    "app_waiter": "APP para Garçom",
    "delivery_manager": "Gerenciador de Entregas",
    "automatic_inventory_control": "Controle Automático de Estoque",
    "domain_hosting": "Hospedagem de Domínio",
    "talk_to_attendant": "FALE COM O ATENDENTE",
    "those_who_use": "Quem usa, recomenda",
    "see_the_models": "Veja os modelos e faça",
    "test_order": "um pedido de teste.",
    "talk_with_attendant": "Fale com o atendente",
    "still_afraid": "Mas ainda estou com receio",
    "wont_work": "de que não funcione, e agora?",
    "we_have_human_team": "Temos uma equipe 100% humana, altamente treinada para te ajudar nesses primeiros passos e sempre que precisar. Agendaremos uma videochamada de onboarding e auxiliaremos nas configurações. Vamos te guiar em cada etapa!",
    "yes_i_wanna_help": "SIM, QUERO AJUDA",
    "days_of_satisfaction": "7 dias de satisfação",
    "or_your_money_back": "ou seu dinheiro de volta!",
    "i_belive_in_the_results": "Acredito tanto nos resultados que a plataforma WhatsMenu.PRO trará para você que ofereço uma garantia de 7 dias para testar. Se não estiver satisfeito ou se arrepender por qualquer motivo, basta entrar em contato comigo no WhatsApp e eu reembolsarei 100% do seu dinheiro.",
    "talk_with_us_on_WhatsApp": "Fale conosco pelo WhatsApp",
    "what_is_your_name": "Qual é o seu nome?",
    "what_is_your_WhatsApp": "Qual é o seu WhatsApp?",
    "what_product_you_sell": "Que produto você vende?",
    "Browse": "Navegue",
    "how_works": "COMO FUNCIONA",
    "features": "RECURSOS",
    "clients": "CLIENTES",
    "examples": "EXEMPLOS",
    "team": "EQUIPE",
    "support": "SUPORTE",
    "access_dashboard": "ACESSAR PAINEL",
    "right_reserved": "Todos os direitos reservados.",
    "digital_menu": "MENU DIGITAL",
    "delivery": "ENTREGA",
    "call": "LIGUE AGORA!"
  },
  "last_name": "Sobrenome",
  "secret_number": "CPF",
  "enter_motoboys_secret_number": "Digite o CPF do Entregador",
  "enter_your_last_name": "Insira seu Sobrenome",
  "invalid_cpf": "CPF inválido",
  "support": "Suporte",
  "logistics_management": "Gestão Logística",
  "logistics_description": "Elimine atrasos e erros de rotas, acompanhe todos os seus entregadores em tempo real no mapa GPS, entregue uma experiencia exclusiva no pedido de seus clientes.",
  "logistics_mottu": "Entregas rápidas e seguras",
  "printers": "Impressoras",
  "view": "Ver",
  "reload": "Recarregar",
  "force_reload": "Forçar Recarregar",
  "console": "Console",
  "print_auto": "Imprimir Automaticamente",
  "custom": "Personalizado",
  "no_margin": "Sem Margem",
  "minimum_margin": "Margem Mínima",
  "scale": "Escala",
  "scale_print": "Escala da impressão",
  "scale_percentage": "Escala em porcentagem",
  "add_printer": "Adicionar Impressora",
  "printers_available": "Impressoras Disponíveis",
  "no_printer_available": "Nenhuma Impressora Disponível",
  "select_printer": "Selecione uma Impressora",
  "select_printer_detail": "Selecione uma Impressora, caso não queira impressão automática desmarque a caixa \"Imprimir Automaticamente\"",
  "paper_size": "Tamanho do Papel",
  "select_paper_size": "Selecione o tamanho do papel",
  "legacy_printer": "Impressão legado",
  "config_ambient_printer": "Configurar ambientes",
  "paper_width": "Largura do papel",
  "paper_width_detail": "Valor e milimetros (mm)",
  "copies_quantity": "Quantidade de Cópias",
  "dashboard": "Painel",
  "dashboard_title": "Dashboard",
  "dashboard_business_summary": "Resumo do negócio",
  "dashboard_overview": "Visão geral",
  "dashboard_overview_title": "Seu restaurante em um olhar",
  "dashboard_overview_hint": "Clique em qualquer gráfico para abrir insights detalhados.",
  "dashboard_cache_valid": "cache válido",
  "dashboard_cache_expired": "cache expirado",
  "dashboard_loading_report": "Carregando relatório de analytics...",
  "dashboard_load_error": "Não foi possível carregar os dados de analytics.",
  "dashboard_period_prefix": "Acompanhe o desempenho do seu restaurante no período de",
  "dashboard_period_to": "a",
  "dashboard_next_update": "Próxima atualização",
  "dashboard_status_orders": "Status dos pedidos",
  "dashboard_approved": "Aprovados",
  "dashboard_preparing": "Preparando",
  "dashboard_in_delivery": "Em entrega",
  "dashboard_delivered": "Entregues",
  "dashboard_cancelled": "Cancelados",
  "dashboard_top_deliverers": "Top entregadores",
  "dashboard_deliveries_in_period": "Entregas no período",
  "dashboard_no_data_period": "Sem dados no período.",
  "dashboard_cash_and_goals": "Caixa e metas",
  "dashboard_opening": "Abertura",
  "dashboard_entries": "Entradas",
  "dashboard_outflows": "Saídas",
  "dashboard_current_balance": "Saldo atual",
  "dashboard_monthly_goal": "Meta mensal",
  "dashboard_current": "Atual",
  "dashboard_goal": "Meta",
  "dashboard_progress": "Progresso",
  "chart_insights_default_title": "Insights do gráfico",
  "chart_insights_default_subtitle": "Análise contextual de dados e cruzamentos.",
  "chart_insights_close_panel": "Fechar painel",
  "chart_insights_empty_state": "Sem insights suficientes para este gráfico no período selecionado.",
  "chart_insights_next_step": "Próximo passo",
  "insight_tone_critical": "CRÍTICO",
  "insight_tone_attention": "ATENÇÃO",
  "insight_tone_info": "INFO",
  "insight_tone_success": "SUCESSO",
  "insight_tone_opportunity": "OPORTUNIDADE",
  "insight_tone_analysis": "ANÁLISE",
  "analytics_action_adjust_menu": "Ajustar cardápio",
  "analytics_action_campaigns": "Campanhas",
  "analytics_action_configure_cashback": "Configurar cashback",
  "analytics_action_configure_coupons": "Configurar cupons",
  "analytics_action_configure_payments": "Configurar pagamentos",
  "analytics_action_create_conversion_coupon": "Criar cupom de conversão",
  "analytics_action_create_coupon": "Criar cupom",
  "analytics_action_create_first_purchase_coupon": "Criar cupom 1a compra",
  "analytics_action_create_hour_promotion": "Criar promoção por horário",
  "analytics_action_create_promotion": "Criar promoção",
  "analytics_action_follow_deliveries": "Acompanhar entregas",
  "analytics_action_follow_map": "Acompanhar mapa",
  "analytics_action_manage_campaigns": "Gerenciar campanhas",
  "analytics_action_open_orders": "Abrir pedidos",
  "analytics_action_view_campaigns": "Ver campanhas",
  "analytics_action_view_cash": "Ver caixa",
  "analytics_action_view_coupons": "Ver cupons",
  "analytics_action_view_order_channels": "Ver pedidos por canal",
  "analytics_action_view_order_map": "Ver mapa de pedidos",
  "analytics_action_view_orders": "Ver pedidos",
  "analytics_campaign_efficiency_message": "Campanha líder {{code}} com {{roi}}x de ROI e retorno de {{value}}.",
  "analytics_campaign_efficiency_message_none": "Sem campanhas suficientes para ranquear retorno por cupom.",
  "analytics_campaign_efficiency_next": "Escalar campanha de melhor ROI e pausar campanhas abaixo do limiar mínimo.",
  "analytics_campaign_efficiency_title": "Eficiência financeira das campanhas",
  "analytics_category_finance": "Financeiro",
  "analytics_category_marketing": "Marketing",
  "analytics_category_operations": "Operações",
  "analytics_category_relationship": "Relacionamento",
  "analytics_channel_conversion_message": "A conversão para entregues está em {{value}}. Canais com mais volume precisam de fluxo mais previsível para não aumentar perdas.",
  "analytics_channel_conversion_next": "Comparar cancelamento por tipo de pedido e priorizar ajuste no canal de maior atrito.",
  "analytics_channel_conversion_title": "Canal e conversão final",
  "analytics_chart_clients_title": "Insights de Clientes",
  "analytics_chart_location_title": "Insights de Localização",
  "analytics_conversion_revenue_message": "A taxa do funil em entregues está em {{value}}. Melhorar etapas finais impacta faturamento sem aumentar custo de aquisição no mesmo nível.",
  "analytics_conversion_revenue_next": "Atuar nos status com maior fila e reduzir tempo entre preparo e entrega.",
  "analytics_conversion_revenue_title": "Receita depende da conversão final",
  "analytics_coupon_dependency_message": "{{value}} dos pedidos usam cupom. Esse indicador deve crescer junto com ROI, não apenas com volume.",
  "analytics_coupon_dependency_message_none": "Não há pedidos suficientes para medir dependência de cupom.",
  "analytics_coupon_dependency_next": "Definir limite de uso por dia e trocar parte dos descontos por frete estratégico.",
  "analytics_coupon_dependency_title": "Dependência de desconto no volume",
  "analytics_customer_retention_message": "Há {{recurring}} clientes recorrentes contra {{new}} novos no período.",
  "analytics_customer_retention_message_none": "Sem base de clientes suficiente para calcular retenção.",
  "analytics_customer_retention_next": "Aplicar campanha de recompra para clientes novos em até 7 dias após o primeiro pedido.",
  "analytics_customer_retention_title": "Retenção de clientes em {{value}}",
  "analytics_delivery_capacity_message_active": "Cruzar pico horário com escala dos entregadores ajuda a reduzir fila e tempo de ciclo.",
  "analytics_delivery_capacity_message_none": "Não há entregadores mapeados no período, o que reduz rastreabilidade operacional.",
  "analytics_delivery_capacity_next_active": "Ajustar escala dos top entregadores para cobrir faixa de maior demanda.",
  "analytics_delivery_capacity_next_none": "Validar integração de entregadores e preenchimento de motoboyId nos pedidos.",
  "analytics_delivery_capacity_title": "Capacidade de entrega no horário de pressão",
  "analytics_demand_redistribution_message": "Uso de cupons em {{value}} dos pedidos pode ser usado para empurrar demanda para horas de vale sem derrubar margem global.",
  "analytics_demand_redistribution_next": "Criar campanha de horário de baixa com limite diário e monitorar ticket médio.",
  "analytics_demand_redistribution_title": "Redistribuir demanda com incentivo controlado",
  "analytics_faturamento_meta_achieved": "A meta do mês foi atingida com base no faturamento atual.",
  "analytics_faturamento_meta_missing": "No ritmo atual, ainda faltam {{value}} para a meta.",
  "analytics_faturamento_meta_next_achieved": "Travar nova meta incremental para o próximo ciclo e preservar margem.",
  "analytics_faturamento_meta_next_missing": "Reforçar campanhas nos horários com melhor conversão e maior ticket médio.",
  "analytics_faturamento_meta_title": "Meta mensal em {{value}}",
  "analytics_geographic_demand_message": "{{city}} representa {{value}} dos pedidos com localização.",
  "analytics_geographic_demand_message_none": "Sem dados suficientes para identificar concentração geográfica.",
  "analytics_geographic_demand_next": "Criar campanha por cidade com verba proporcional ao volume e potencial de expansão.",
  "analytics_geographic_demand_title": "Concentração geográfica da demanda",
  "analytics_insights_auto_subtitle": "Insights automáticos com cruzamento de KPIs, funil, cupons e operação.",
  "analytics_margin_coupon_message": "Com {{value}} dos pedidos usando cupom, acompanhar margem por produto com desconto evita crescimento com erosão de lucro.",
  "analytics_margin_coupon_next": "Criar regra de cupom priorizando itens com margem maior para preservar resultado.",
  "analytics_margin_coupon_title": "Margem e dependência de cupom",
  "analytics_metric_active_deliverers": "Entregadores ativos",
  "analytics_metric_average_roi": "ROI médio",
  "analytics_metric_average_ticket": "Ticket médio",
  "analytics_metric_avg_7d_current": "Média 7d atual",
  "analytics_metric_avg_7d_previous": "Média 7d anterior",
  "analytics_metric_cancelled": "Cancelamentos",
  "analytics_metric_conversion_rate": "Taxa de conversão",
  "analytics_metric_coupon_investment": "Investimento em cupom",
  "analytics_metric_coupon_return": "Retorno de cupons",
  "analytics_metric_coupon_usage": "Uso de cupons",
  "analytics_metric_coupons_used": "Cupons usados",
  "analytics_metric_current_revenue": "Faturamento atual",
  "analytics_metric_delivered": "Entregues",
  "analytics_metric_delivery": "Delivery",
  "analytics_metric_funnel_conversion": "Conversão do funil",
  "analytics_metric_in_delivery_now": "Em entrega agora",
  "analytics_metric_items_margin_below_20": "Itens com margem < 20%",
  "analytics_metric_leading_city": "Cidade líder",
  "analytics_metric_leading_city_orders": "Pedidos da líder",
  "analytics_metric_leading_method": "Método líder",
  "analytics_metric_leading_neighborhood": "Bairro líder",
  "analytics_metric_leading_share": "Participação líder",
  "analytics_metric_mapped_cities": "Cidades mapeadas",
  "analytics_metric_month_goal": "Meta do mês",
  "analytics_metric_neighborhood_orders": "Pedidos no bairro",
  "analytics_metric_new_customers": "Clientes novos",
  "analytics_metric_orders": "Pedidos",
  "analytics_metric_orders_in_period": "Pedidos no período",
  "analytics_metric_orders_peak": "Pedidos no pico",
  "analytics_metric_peak_hour": "Hora de pico",
  "analytics_metric_pickup": "Retirada",
  "analytics_metric_preparing": "Preparando",
  "analytics_metric_recurring_customers": "Clientes recorrentes",
  "analytics_metric_revenue": "Faturamento",
  "analytics_metric_revenue_variation": "Variação faturamento",
  "analytics_metric_table": "Mesa",
  "analytics_metric_top_product": "Top produto",
  "analytics_metric_total_investment": "Investimento total",
  "analytics_metric_total_orders": "Pedidos totais",
  "analytics_metric_total_processed": "Total processado",
  "analytics_metric_total_product_profit": "Lucro total produtos",
  "analytics_metric_total_return": "Retorno total",
  "analytics_metric_usage_rate": "Taxa de uso",
  "analytics_order_channel_mix_message": "Delivery representa {{delivery}}, retirada {{withdrawal}} e mesa {{table}}.",
  "analytics_order_channel_mix_message_none": "Sem dados de pedidos por tipo no período.",
  "analytics_order_channel_mix_next": "Ajustar capacidade operacional por canal para reduzir gargalos de atendimento.",
  "analytics_order_channel_mix_title": "Mix de canais de pedido",
  "analytics_payment_concentration_message": "{{method}} representa {{value}} do volume financeiro dos pagamentos.",
  "analytics_payment_concentration_message_none": "Sem dados suficientes de pagamento para identificar concentração.",
  "analytics_payment_concentration_next_balanced": "Manter mix equilibrado e acompanhar custo por adquirente.",
  "analytics_payment_concentration_next_high": "Oferecer alternativa com incentivo leve para reduzir dependência de um único método.",
  "analytics_payment_concentration_title": "Concentração por método de pagamento",
  "analytics_payment_mix_ticket_message": "Com ticket médio de {{value}}, o mix de pagamentos deve ser monitorado junto ao custo transacional para proteger margem líquida.",
  "analytics_payment_mix_ticket_message_none": "Sem pedidos suficientes para correlacionar ticket e mix de pagamentos.",
  "analytics_payment_mix_ticket_next": "Cruzar taxa de adquirência por método com o ticket médio semanal.",
  "analytics_payment_mix_ticket_title": "Mix de pagamentos e ticket médio",
  "analytics_peak_message_high": "Alta concentração em uma única hora aumenta risco de atraso, ruptura e queda de experiência.",
  "analytics_peak_message_none": "Sem concentração horária detectada no período atual.",
  "analytics_peak_next_high": "Abrir turno reforçado para 1h antes e 1h depois do pico e monitorar SLA de entrega.",
  "analytics_peak_next_none": "Coletar mais pedidos para estabelecer padrão de demanda por hora.",
  "analytics_peak_title": "Pico em {{hour}} concentra {{value}}",
  "analytics_product_profit_message": "{{product}} concentra {{value}} do lucro dos produtos líderes.",
  "analytics_product_profit_message_none": "Não há dados suficientes para avaliar concentração de lucro por produto.",
  "analytics_product_profit_next": "Expandir venda dos produtos de margem alta e revisar precificação dos itens de baixa margem.",
  "analytics_product_profit_title": "Concentração de lucro por produto",
  "analytics_retention_growth_message": "Crescimento sustentável tende a combinar aquisição de novos clientes com aumento de recorrência e ticket médio consistente.",
  "analytics_retention_growth_next": "Segmentar clientes novos por bairro e horário para melhorar segunda compra.",
  "analytics_retention_growth_title": "Retenção e crescimento de receita",
  "analytics_top_neighborhood_message": "{{neighborhood}} em {{city}} lidera demanda e deve orientar escala operacional e prazo prometido.",
  "analytics_top_neighborhood_message_none": "Sem bairros suficientes para sugerir priorização operacional.",
  "analytics_top_neighborhood_next": "Revisar SLA de entrega no bairro líder e criar oferta local de retenção.",
  "analytics_top_neighborhood_title": "Bairro mais ativo para priorização",
  "analytics_trend_last_7d_message": "A média diária recente está em {{value}} ({{delta}} vs. 7 dias anteriores).",
  "analytics_trend_last_7d_next": "Usar os dias com maior receita para definir calendário de ofertas e equipe.",
  "analytics_trend_last_7d_next_no_data": "Acumular ao menos 14 dias para liberar comparações robustas de tendência.",
  "analytics_trend_last_7d_no_data": "Ainda não há histórico suficiente para comparar duas janelas de 7 dias.",
  "analytics_trend_last_7d_title": "Tendência dos últimos 7 dias",
  "whatsapp_bot": "Robô do WhatsApp",
  "disabled_menu": "Cardápio Desativado - Procure o Estabelecimento.",
  "login": "Acessar",
  "forgot_password": "Esqueci a senha",
  "logout": "Sair",
  "pos_videos": "Videos PDV",
  "download_desktop_title": "Baixe agora o NOVO WhatsMenu Desktop",
  "download_desktop_subtitle": "Menos Trabalho e Mais Vendas",
  "download_desktop_bot": "Atendente virtual para WhatsApp",
  "download_desktop_fidelity": "Programa de Fidelidade",
  "download_desktop_cashback": "CashBack",
  "download_desktop_first_coupon": "Cupom de primeira compra",
  "download_desktop_sales_bot": "Robô de vendas automatizadas",
  "download_desktop_no_tabs": "Envio de status sem abertura de abas",
  "download_app": "Baixar aplicativo",
  "how_to_use": "Veja como usar",
  "invoice_available": "Fatura de mensalidade disponível para pagamento! Clique aqui.",
  "payment_overdue": "Seu cardápio pode ser bloqueado, pois sua mensalidade está em atraso! Clique aqui.",
  "tables_link": "Link das mesas",
  "update_desktop_title": "Novo WhatsMenu Desktop",
  "update_desktop_message": "Mais leve e mais rápido - Maior eficiência nos controles de mensagens.",
  "update_desktop_button": "ATUALIZE AGORA",
  "bot_step1": "Abra o WhatsApp no seu celular.",
  "bot_step2.1": "Toque em",
  "bot_step2.2": "Mais opções",
  "bot_step2.3": "no Android ou em",
  "bot_step2.4": "Configurações",
  "bot_step2.5": "no iPhone.",
  "bot_step3.1": "Toque em",
  "bot_step3.2": "Dispositivos conectados",
  "bot_step3.3": "e, em seguida, em",
  "bot_step3.4": "Conectar dispositivo.",
  "bot_step4": "Aponte seu celular para esta tela para escanear o QR code.",
  "connected": "Conectado",
  "disconnected": "Desconectado",
  "connection_error": "Erro ao conectar",
  "disconnect": "Desconectar",
  "try_again": "Tentar novamente",
  "customer_service_bot": "Robô de atendimento",
  "bot_attention": "ATENÇÃO!",
  "phone_sync_warning": "Mantenha a tela do seu celular aberta até que a tela de sincronização feche sozinha!",
  "loading_messages": "Carregando mensagens...",
  "print_env_config": "Configuração de Ambiente de Impressão",
  "print_env_edit": "Edição de Ambiente de Impressão",
  "print_type": "Tipo de Impressão",
  "fiscal_printer": "Impressão Fiscal",
  "production_printer": "Impressão de Produção de Pedido",
  "env_name": "Nome do Ambiente",
  "enter_env_name": "Digite o nome do ambiente",
  "prod_categories": "Categorias de Produtos",
  "select_prod_category": "Selecione as categorias de produtos para incluir na impressão.",
  "save_edit": "Salvar Edição",
  "environment": "Ambiente",
  "print_env": "Ambiente de Impressão",
  "env_register": "Cadastrar Ambiente",
  "printer_config": "Configurar Impressoras",
  "edit_envs": "Editar Ambientes da",
  "print_envs": "Ambientes de impressão",
  "select_envs": "Selecione os ambientes que deseja atribuir à",
  "bot_send_menu": "Envio do cardápio pelo robô",
  "bot_not_allow_attendant": "Não permitir falar com atendente",
  "selected_item": "Item selecionado",
  "selected_items": "Itens selecionados",
  "canceled_items": "Itens cancelados",
  "select_state": "Selecione o estado",
  "enter_the_address_number": "Digite número do endereço",
  "call": "LIGUE AGORA!",
  "denmark": "Dinamarca (kr)",
  "english_ie": "Inglês (Irlanda)",
  "finland": "Finlândia (€)",
  "france": "França (€)",
  "germany": "Alemanha (€)",
  "italy": "Itália (€)",
  "kg_or_l": "kg ou L",
  "norway": "Noruega (kr)",
  "now_accepting_scheduled_orders": "Aberto para agendamentos",
  "out_for_delivery": "saiu para entrega",
  "spain": "Espanha (€)",
  "sweden": "Suécia (kr)",
  "switzerland": "Suíça (CHF)",
  "AF": "Afeganistão",
  "AX": "Ilhas Åland",
  "AL": "Albânia",
  "DZ": "Argélia",
  "AS": "Samoa Americana",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguila",
  "AQ": "Antártida",
  "AG": "Antígua e Barbuda",
  "AR": "Argentina",
  "AM": "Armênia",
  "AW": "Aruba",
  "AC": "Ilha de Ascensão",
  "AU": "Austrália",
  "AT": "Áustria",
  "AZ": "Azerbaijão",
  "BS": "Bahamas",
  "BH": "Bahrein",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Belarus",
  "BE": "Bélgica",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermudas",
  "BT": "Butão",
  "BO": "Bolívia",
  "BA": "Bósnia e Herzegovina",
  "BW": "Botsuana",
  "BR": "Brasil",
  "IO": "Território Britânico do Oceano Índico",
  "BN": "Brunei",
  "BG": "Bulgária",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Camboja",
  "CM": "Camarões",
  "CA": "Canadá",
  "CV": "Cabo Verde",
  "KY": "Ilhas Cayman",
  "CF": "República Centro-Africana",
  "TD": "Chade",
  "CL": "Chile",
  "CN": "China",
  "CX": "Ilha Christmas",
  "CC": "Ilhas Cocos (Keeling)",
  "CO": "Colômbia",
  "KM": "Comores",
  "CG": "Congo",
  "CD": "República Democrática do Congo",
  "CK": "Ilhas Cook",
  "CR": "Costa Rica",
  "CI": "Costa do Marfim",
  "HR": "Croácia",
  "CU": "Cuba",
  "CY": "Chipre",
  "CZ": "República Tcheca",
  "DK": "Dinamarca",
  "DJ": "Djibouti",
  "DM": "Dominica",
  "DO": "República Dominicana",
  "EC": "Equador",
  "EG": "Egito",
  "SV": "El Salvador",
  "GQ": "Guiné Equatorial",
  "ER": "Eritreia",
  "EE": "Estônia",
  "SZ": "Essuatíni",
  "ET": "Etiópia",
  "FK": "Ilhas Malvinas",
  "FO": "Ilhas Faroé",
  "FJ": "Fiji",
  "FI": "Finlândia",
  "FR": "França",
  "GF": "Guiana Francesa",
  "PF": "Polinésia Francesa",
  "GA": "Gabão",
  "GM": "Gâmbia",
  "GE": "Geórgia",
  "DE": "Alemanha",
  "GH": "Gana",
  "GI": "Gibraltar",
  "GR": "Grécia",
  "GL": "Groenlândia",
  "GD": "Granada",
  "GP": "Guadalupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guiné",
  "GW": "Guiné-Bissau",
  "GY": "Guiana",
  "HT": "Haiti",
  "VA": "Vaticano",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hungria",
  "IS": "Islândia",
  "IN": "Índia",
  "ID": "Indonésia",
  "IR": "Irã",
  "IQ": "Iraque",
  "IE": "Irlanda",
  "IM": "Ilha de Man",
  "IL": "Israel",
  "IT": "Itália",
  "JM": "Jamaica",
  "JP": "Japão",
  "JE": "Jersey",
  "JO": "Jordânia",
  "KZ": "Cazaquistão",
  "KE": "Quênia",
  "KI": "Kiribati",
  "KP": "Coreia do Norte",
  "KR": "Coreia do Sul",
  "XK": "Kosovo",
  "KW": "Kuwait",
  "KG": "Quirguistão",
  "LA": "Laos",
  "LV": "Letônia",
  "LB": "Líbano",
  "LS": "Lesoto",
  "LR": "Libéria",
  "LY": "Líbia",
  "LI": "Liechtenstein",
  "LT": "Lituânia",
  "LU": "Luxemburgo",
  "MO": "Macau",
  "MG": "Madagascar",
  "MW": "Malawi",
  "MY": "Malásia",
  "MV": "Maldivas",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Ilhas Marshall",
  "MQ": "Martinica",
  "MR": "Mauritânia",
  "MU": "Maurício",
  "YT": "Mayotte",
  "MX": "México",
  "FM": "Micronésia",
  "MD": "Moldávia",
  "MC": "Mônaco",
  "MN": "Mongólia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MA": "Marrocos",
  "MZ": "Moçambique",
  "MM": "Myanmar",
  "NA": "Namíbia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Países Baixos",
  "NC": "Nova Caledônia",
  "NZ": "Nova Zelândia",
  "NI": "Nicarágua",
  "NE": "Níger",
  "NG": "Nigéria",
  "NU": "Niue",
  "NF": "Ilha Norfolk",
  "MK": "Macedônia do Norte",
  "MP": "Ilhas Marianas do Norte",
  "NO": "Noruega",
  "OM": "Omã",
  "PK": "Paquistão",
  "PW": "Palau",
  "PS": "Palestina",
  "PA": "Panamá",
  "PG": "Papua-Nova Guiné",
  "PY": "Paraguai",
  "PE": "Peru",
  "PH": "Filipinas",
  "PN": "Ilhas Pitcairn",
  "PL": "Polônia",
  "PT": "Portugal",
  "PR": "Porto Rico",
  "QA": "Catar",
  "RE": "Reunião",
  "RO": "Romênia",
  "RU": "Rússia",
  "RW": "Ruanda",
  "BL": "São Bartolomeu",
  "SH": "Santa Helena",
  "KN": "São Cristóvão e Nevis",
  "LC": "Santa Lúcia",
  "MF": "São Martinho",
  "PM": "São Pedro e Miquelon",
  "VC": "São Vicente e Granadinas",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "São Tomé e Príncipe",
  "SA": "Arábia Saudita",
  "SN": "Senegal",
  "RS": "Sérvia",
  "SC": "Seicheles",
  "SL": "Serra Leoa",
  "SG": "Singapura",
  "SX": "Sint Maarten",
  "SK": "Eslováquia",
  "SI": "Eslovênia",
  "SB": "Ilhas Salomão",
  "SO": "Somália",
  "ZA": "África do Sul",
  "GS": "Ilhas Geórgia do Sul e Sandwich do Sul",
  "SS": "Sudão do Sul",
  "ES": "Espanha",
  "LK": "Sri Lanka",
  "SD": "Sudão",
  "SR": "Suriname",
  "SJ": "Svalbard e Jan Mayen",
  "SE": "Suécia",
  "CH": "Suíça",
  "SY": "Síria",
  "TW": "Taiwan",
  "TJ": "Tajiquistão",
  "TZ": "Tanzânia",
  "TH": "Tailândia",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad e Tobago",
  "TN": "Tunísia",
  "TR": "Turquia",
  "TM": "Turcomenistão",
  "TC": "Ilhas Turks e Caicos",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ucrânia",
  "AE": "Emirados Árabes Unidos",
  "GB": "Reino Unido",
  "US": "Estados Unidos",
  "UY": "Uruguai",
  "UZ": "Uzbequistão",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnã",
  "VG": "Ilhas Virgens Britânicas",
  "VI": "Ilhas Virgens Americanas",
  "WF": "Wallis e Futuna",
  "EH": "Saara Ocidental",
  "YE": "Iêmen",
  "ZM": "Zâmbia",
  "ZW": "Zimbábue",
  "highlight_products": "Produtos em destaque",
  "highlight_description": "Confira nossos produtos mais populares!",
  "highlights": "Destaques",
  "highlight_successfuly_updated": "Destaque atualizado com sucesso!",
  "highlight_category": "Categoria de Produtos em Destaque",
  "highlight_explanation": "Seus produtos marcados com estrela terão destaque na sua loja WhatsMenu!",
  "complete_category": "Categoria Completa",
  "fees_settings": "Configurações de taxas",
  "dashboard_auto_assign": "Cupom automático",
  "congrats_auto_assign": "🎉 PARABÉNS! Você ganhou",
  "auto_assign_discount": "de desconto!",
  "store_auto_assign_1": "Adicione mais",
  "store_auto_assign_2": "para ganhar",
  "price_from": "De:",
  "price_to": "Por:",
  "progressive_discount": "Desconto Progressivo",
  "progressive_discounts": "Descontos Progressivos",
  "progressive_discount_manager": "Gestão de Descontos Progressivos",
  "discounts": "Descontos",
  "discount_status": "Status do desconto",
  "delete_discount": "Excluir desconto",
  "delete_discount_confirm": "Tem certeza que deseja excluir o desconto",
  "discount_not_created": "Desconto não criado",
  "discount_not_created_desc": "Não foi possível criar o Desconto",
  "discount_name": "Nome do desconto",
  "discount_already_exists": "Desconto já existe",
  "discount_invalid_chars": "Caracteres especiais não são permitidos",
  "discount_allowed_chars_hint": "Apenas letras, números, hífen (-) e sublinhado (_)",
  "discount_code_valid": "Nome disponível",
  "applied_discount": "Desconto aplicado",
  "invalid_coupom": "O cupom não é válido!",
  "select_your_discount": "Selecione seu desconto",
  "check_for_updates": "Verificar Atualizações",
  "update_alert": "Alerta de atualização",
  "update_unavailable": "Nenhuma atualização disponível.",
  "configure_extra_fees": "Configure abaixo as taxas extras de serviços ou repasses, essas taxas serão cobradas do seu cliente no final de cada pedido. Ex. Couvert artístico, valet, garçom, serviço ou imposto.",
  "fees_already_exists": "Já existe uma taxa com este nome.",
  "fees_name_cannot_be_empty": "Nome da taxa não pode ser vazio.",
  "fees_name_too_long": "Nome da taxa não pode ter mais de 20 caracteres.",
  "fees_min_value": "Insira um valor maior que {{value}}",
  "fees_created": "Taxa {{code}} criada com sucesso",
  "fees_updated": "{{code}}, alterado com sucesso.",
  "fees_deleted": "Taxa {{code}} excluída com sucesso",
  "highlight_limit": "Você pode ter no máximo 10 produtos em destaque.",
  "consider_current_value": "Caso algum valor tenha sido alterado, será considerado o valor atual",
  "unavailable_products": "Produtos indisponíveis",
  "unavailable_products_desc": "Os seguintes produtos e/ou seus complementos estão indisponíveis",
  "continue_anyway": "Continuar mesmo assim",
  "total_clients": "Total de Clientes",
  "inactive_30d": "Inativos há +30 dias",
  "new_clients": "Novos Clientes",
  "last_order": "Último Pedido",
  "favorite_product": "Produto Favorito",
  "segment": "Segmento",
  "inactive_client": "Inativo",
  "new_client": "Novo",
  "recurring_client": "Recorrente",
  "loyal_client": "Fiel",
  "days_ago": "{{count}}d atrás",
  "days_without_order": "{{count}}d sem pedir",
  "segments": "Segmentos",
  "clear_filters": "Limpar filtros",
  "inactive_days_label": "Sem pedido há (dias)",
  "min_ticket_label": "Ticket mín.",
  "max_ticket_label": "Ticket máx.",
  "client_analysis": "Análise do Cliente",
  "cancellation_rate": "Taxa de Cancelamento",
  "mom_change": "Variação M/M",
  "biggest_order": "Maior Pedido",
  "smallest_order": "Menor Pedido",
  "most_ordered_products": "Produtos Mais Pedidos",
  "no_data": "Sem dados",
  "monthly_frequency": "Frequência Mensal",
  "trend_up": "↑ crescente",
  "trend_down": "↓ decrescente",
  "trend_stable": "→ estável",
  "avg_ticket_by_month": "Ticket Médio por Mês",
  "preferred_order_days": "Dias Preferidos para Pedir",
  "repurchase_interval": "Intervalo de Recompra",
  "average": "Média",
  "median": "Mediana",
  "samples": "Amostras",
  "requires_at_least_2_orders": "Necessário ao menos 2 pedidos",
  "export_csv": "Exportar CSV",
  "no_client_found_by_name": "Nenhum cliente encontrado com esse nome",
  "based_on_last_orders": "Baseado nos últimos {{count}} de {{total}} pedidos",
  "segment_inactive_15d": "Inativos 15d",
  "segment_inactive_30d": "Inativos 30d",
  "segment_inactive_60d": "Inativos 60d",
  "segment_new_1_order": "Novos (1 pedido)",
  "segment_high_ticket": "Alto ticket",
  "back_to_list_detail": "← Voltar à lista",
  "highlight": "Destaque",
  "trend": "Tendência",
  "weighted_average": "Média Ponderada",
  "intervals": "Intervalos",
  "low_confidence_sample": "⚠ baixa amostra",
  "intervals_in_range": "intervalo(s) nesta faixa",
  "ticket_label": "Ticket",
  "total_label": "Total",
  "no_orders_this_month": "Sem pedidos neste mês",
  "block_date": "Data de Bloqueio",
  "payment_date": "Data de Pagamento",
  "can_the_customer_eat_here": "O cliente pode pedir para comer no local",
  "cmv_report_title": "Relatório de CMV",
  "cmv_health_score": "Score de Saúde",
  "cmv_alert_critical": "produtos com CMV crítico!",
  "cmv_alert_critical_desc": "Produtos com CMV acima de 35% comprometem a lucratividade.",
  "cmv_alert_potential_savings": "Economia potencial por unidade:",
  "cmv_alert_priority_products": "Produtos prioritários para revisão:",
  "cmv_coverage_title": "Cobertura de custos:",
  "cmv_coverage_desc": "produtos sem custo cadastrado. Cadastre os custos para análise completa e decisões precisas.",
  "cmv_success_title": "Excelente! Sua precificação está saudável",
  "cmv_success_desc": "Nenhum produto com CMV crítico. Continue monitorando regularmente.",
  "cmv_avg": "CMV Médio",
  "cmv_very_high": "CMV Muito Alto",
  "cmv_ideal": "CMV Ideal",
  "cmv_very_low": "Muito Baixo",
  "cmv_no_cost": "Sem Custo",
  "cmv_urgent_action": "Ação urgente",
  "cmv_perfect": "Perfeito",
  "cmv_register_costs": "Cadastrar custos",
  "cmv_see_products": "Ver produtos",
  "cmv_search_product": "Buscar Produto",
  "cmv_search_placeholder": "Nome ou categoria...",
  "cmv_category": "Categoria",
  "cmv_all_categories": "Todas",
  "cmv_type": "Tipo",
  "cmv_delivery": "Delivery",
  "cmv_table": "Mesa",
  "cmv_status": "Status CMV",
  "cmv_all_status": "Todos",
  "cmv_export_excel": "Exportar Excel",
  "cmv_showing": "Mostrando",
  "cmv_of": "de",
  "cmv_products": "produtos",
  "cmv_with_costs": "com custos cadastrados",
  "cmv_how_to_interpret": "Como interpretar o CMV:",
  "cmv_very_high_desc": "Custo muito elevado. Negocie fornecedores ou ajuste preço.",
  "cmv_ideal_desc": "Faixa saudável de lucratividade.",
  "cmv_very_low_desc": "Margem alta. Considere estratégias promocionais.",
  "cmv_updated_at": "Atualizado em:",
  "cmv_loading": "Carregando análise de CMV...",
  "cmv_product": "Produto",
  "cmv_sale_price": "Preço Venda",
  "cmv_cost": "Custo",
  "cmv_no_products_found": "Nenhum produto encontrado com os filtros aplicados",
  "cmv_no_products_yet": "Nenhum produto cadastrado ainda",
  "cmv_clear_filters": "Limpar filtros",
  "cmv_disclaimer_1": "O CMV (Custo da Mercadoria Vendida) representa apenas custos diretos de aquisição/produção.",
  "cmv_disclaimer_2": "Impostos, comissões, frete, embalagens e custos fixos (aluguel, energia) não estão incluídos neste cálculo.",
  "cmv_insight_title": "Análise de CMV",
  "cmv_insight_delivery": "Delivery",
  "cmv_insight_table": "Mesa",
  "cmv_insight_margin": "Margem",
  "cmv_insight_profit_per_sale": "Lucro por venda",
  "cmv_insight_status_critical": "CMV Crítico!",
  "cmv_insight_status_high": "CMV Alto",
  "cmv_insight_status_ideal": "CMV Ideal",
  "cmv_insight_status_low": "CMV Muito Baixo",
  "cmv_insight_suggestion_critical": "Renegocie fornecedores ou aumente o preço",
  "cmv_insight_suggestion_high": "Considere ajustar custo ou preço de venda",
  "cmv_insight_suggestion_ideal": "Margem saudável! Continue monitorando",
  "cmv_insight_suggestion_low": "Ótima margem! Considere criar promoções",
  "cmv_insight_enter_cost": "Preencha o custo para ver análise",
  "cmv_insight_enter_price": "Preencha o preço para ver análise",
  "eat_on_site": "Comer no Local",
  "eat_on_local_subtitle": "Consumo na loja, sem taxa de entrega e embalagem",
  "Can_the_customer_eat_here":"O cliente pode pedir para comer no local",
  "cart_type":"Tipo",
  "eat_here":"Vou comer no local",
  "flavor_badge_configure": "Configurar Flag",
  "flavor_badge_text_label": "Texto da Flag",
  "flavor_badge_text_placeholder": "Ex: Novo, Mais pedido",
  "flavor_badge_color_label": "Cor da Flag",
  "flavor_badge_color_hint": "Escolha a cor de fundo",
  "flavor_badge_name_fallback": "Nome do Sabor",
  "flavor_badge_description_fallback": "Sua descrição aqui...",
  "flavor_badge_preview_alt": "Pré-visualização",
  "flavor_badge_remove": "Remover flag",
  "flavor_badge_add": "+ flag",
  "table_quick_search": "Busca rápida",
  "table_search_placeholder": "Mesa, número ou garçom",
  "table_status_filter_label": "Status da mesa",
  "table_filter_all": "Todas",
  "table_filter_open": "Abertas",
  "table_filter_closed": "Fechadas",
  "table_payment_filter_label": "Pagamento",
  "filter_all": "Todos",
  "payment_status_paid": "Pago",
  "payment_status_partial": "Parcial",
  "payment_status_pending": "Pendente",
  "table_filter_by_command": "Filtrar por comanda ({{count}})",
  "table_select_all": "Selecionar todas",
  "table_clear_all": "Limpar",
  "table_waiter_filter_label": "Garçom",
  "table_open_badge": "Aberta",
  "table_closed_badge": "Fechada",
  "table_orders_pending_tooltip": "{{count}} pedido(s) aguardando",
  "table_order_singular": "pedido",
  "table_order_plural": "pedidos",
  "table_orders_cancelled": "cancelado(s)",
  "table_open_duration": "aberta há {{hours}}h{{minutes}}min",
  "table_closed_duration": "permaneceu aberta por {{hours}}h{{minutes}}min",
  "table_no_time": "sem horário",
  "table_waiter_name_label": "Garçom:",
  "payment_cleared": "Pagamento quitado",
  "payment_partial_label": "Pagamento parcial",
  "payment_pending_label": "Pagamento pendente",
  "table_total_value_label": "Total:",
  "nfe_emitted_tooltip": "NFC-e foi emitida",
  "nfe_emit_tooltip": "Emitir NFC-e",
  "nfe_no_eligible_orders": "Sem pedidos elegíveis para emissão",
  "nfe_close_table_first": "Feche a mesa para emitir NFC-e",
  "nfe_emitted_alt": "NFC-e emitida da mesa",
  "nfe_emit_table_alt": "Emitir NFC-e da Mesa",
  "nfe_blocked_alt": "NFC-e bloqueada",
  "table_paid_label": "Pago:",
  "table_due_label": "Falta:",
  "table_fixed_fee_label": "Taxa fixa:",
  "table_percentage_fee_label": "Taxa percentual:",
  "table_print_col": "Impr",
  "table_order_code_col": "Cód. Pedido",
  "table_name_col": "Nome",
  "table_total_col": "Total",
  "table_time_col": "Hora",
  "table_status_col": "Status",
  "table_served_status": "Servido",
  "table_fees_footer": "Taxas: +{{fixed}} / +{{percentage}}%",
  "table_total_footer_label": "Total da mesa:",
  "table_no_results": "Nenhuma mesa encontrada para os filtros aplicados.",
  "table_name_fallback": "Mesa #{{id}}",
  "table_payment_not_informed": "Não informado",
  "delivery_person_signed_successfully": "Motoboy assinado com sucesso",
  "trackfy_success_add_your_plan": "Roterizador adicionado com sucesso ao seu plano!",
  "can_start_using_trackfy": "Você já pode começar a usar o Roterizador de Entregas agora mesmo.",
  "your_delivery_driver_delivers_faster": "Seu motoboy entrega mais rápido.",
  "your_restaurant_gains_control_productivity_and_peace_of_mind": "Seu restaurante ganha controle, produtividade e tranquilidade.",
  "the_order_is_ready_in_the_kitchen": "O pedido fica pronto na cozinha.",
  "someone_needs_to_call_the_delivery_driver": "Alguém precisa chamar o motoboy.",
  "the_customer_starts_asking_on_whatsapp_if_the_order_has_already_left": "O cliente começa a perguntar no WhatsApp se o pedido já saiu.",
  "the_driver_arrives_at_the_address_and_waits_for_the_customer": "O motoboy chega no endereço e fica esperando o cliente descer, procurar cartão, pegar dinheiro ou abrir o portão.",
  "meanwhile_another_delivery_gets_delayed": "Enquanto isso, outra entrega atrasa.",
  "the_order_is_ready": "O pedido ficou pronto.",
  "call_the_next_driver": "Chame o motoboy da vez.",
  "the_driver_is_out_for_delivery": "O motoboy saiu para entrega.",
  "the_customer_receives_the_tracking_link_via_whatsapp": "O cliente recebe o link de rastreio pelo WhatsApp.",
  "the_customer_tracks_in_real_time": "O cliente acompanha em tempo real.",
  "he_sees_where_the_driver_is_on_the_map": "Ele vê onde o entregador está no mapa.",
  "the_driver_is_arriving": "O entregador está chegando.",
  "the_customer_receives_a_notification": "O cliente recebe um aviso para se preparar para receber o pedido.",
  "small_restaurant_up_to_5_deliveries_per_day": "Restaurante pequeno, até 5 entregas/dia.",
  "140_deliveries": "140 entregas",
  "300_deliveries": "300 entregas",
  "600_deliveries": "600 entregas",
  "1100_deliveries": "1.100 entregas",
  "2000_deliveries": "2.000 entregas",
  "growing_operation_up_to_10_deliveries_per_day": "Operação em crescimento, até 10 entregas/dia.",
  "strong_delivery_business_up_to_20_deliveries_per_day": "Delivery forte, até 20 entregas/dia.",
  "high_volume_up_to_37_deliveries_per_day": "Alto volume, até 37 entregas/dia.",
  "large_operations_up_to_67_deliveries_per_day": "Operações grandes, até 67 entregas/dia.",
  "stop_answering_customers_on_whatsapp": "Para de responder cliente no WhatsApp perguntando se o pedido já saiu.",
  "stop_wasting_time_waiting_for_customers": "Para de perder tempo esperando o cliente se preparar para receber.",
  "track_delivery_via_whatsapp": "Acompanha a entrega pelo WhatsApp e sabe quando o pedido está chegando.",
  "everything_happens_automatically": "Tudo acontece automaticamente, com mais controle e menos correria.",
  "map_view": "Visualização em Mapa",
  "how_it_works": "Como funciona",
  "benefits": "Benefícios",
  "plans": "Planos",
  "automatic_delivery_tracking_and_management": "Rastreio e gestão automática de entregas",
  "your_customer_stops_asking": "Seu cliente para de perguntar:",
  "where_is_my_order": "Cadê meu pedido?",
  "trackfy_description": "O Trackfy automatiza a chamada dos motoboys, envia o rastreio da entrega para o cliente pelo WhatsApp e avisa quando o entregador está chegando. Tudo de forma simples, rápida e automática.",
  "i_want_to_try_now_50_free_deliveries": "QUERO TESTAR AGORA 50 CORRIDAS GRÁTIS!",
  "ideal_for_restaurants": "Ideal para restaurantes com entregadores próprios ou freelancer.",
  "the_problem_is_not_just_the_delivery": "O problema não é só a entrega.",
  "it_is_the_time_lost_around_it": "É o tempo perdido em volta dela.",
  "every_restaurant_knows_this_routine": "Todo restaurante que trabalha com delivery conhece essa rotina:",
  "restaurant_loses_time": "No fim, o restaurante perde tempo, o motoboy perde produtividade e o cliente fica insatisfeito.",
  "what_changes_with_trackfy": "O que muda com o Trackfy",
  "trackfy_is_for_restaurants": "O Trackfy é para restaurantes que querem entregar melhor",
  "more_than_tracking": "Mais do que rastreio, Trackfy é a ferramenta certa para você ter eficiência, controle, resultado financeiro e encantar seus clientes.",
  "choose_the_best_plan": "Escolha o melhor plano para sua operação",
  "for_who": "Para quem",
  "tracked_deliveries_per_month": "Entregas rastreadas/mês",
  "monthly_price": "Valor mensal",
  "most_popular": "MAIS POPULAR",
  "stop_working_in_the_dark": "Pare de trabalhar no escuro depois que o pedido sai da cozinha",
  "with_trackfy": "Com o Trackfy, seu cliente acompanha a entrega sozinho, seu motoboy ganha tempo e seu restaurante opera com muito mais controle.",
  "delivery_tracking_and_management": "Rastreio e gestão automática de entregas",
  "restaurant": "Restaurante",
  "operation": "Operação",
  "error_starting_subscription": "Erro ao iniciar assinatura:",
  "icon_category": "Ícone da Categoria",
  "icon_category_optional": "Ícone da categoria (opcional)",
  "cancelled_parentheses": "(CANCELADO)",
  "news": "Novidades",
  "cashback_message": "Você faturou R$ {{cartTotalCashback}} impulsionados por R$ {{cartTotalCashbackValue}} em cashback.",
  "group_fees": "Agrupar taxas",
  "technical_support": "Suporte Técnico",
  "everyday": "segunda à domingo"
}
